<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">   
      <div :class="item.id==searchtype ? 'mall-goods-show-spu mall-goods-show-spu-on' : 'mall-goods-show-spu'" 
           v-for="(item,i) in searchtypelists" :key="i"
           @click="changesearchtypes(item.id)" >
          {{item.name}}
      </div>      
      <div class="backborder1" v-if="searchtype==1">
             <el-form :inline="true" class="demo-form-inline" ref="query" :model="query" size="small" style="margin-top:10px">
                <!-- <el-form-item v-if="agentlists.length > 1">
                    <el-select v-model="query.parentagentid" filterable clearable @change="changeagents" placeholder="请选择商品来源">
                        <el-option v-for="(item,index) in agentlists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                </el-form-item> -->

                <!-- 是否是分销商品 -->
                <el-form-item style="width:8%" v-if="issplit==true">
                    <el-select v-model="query.splitid" filterable clearable @change="changesearch" placeholder="分销商品">
                        <el-option v-for="(item,index) in splitlists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 是否上下架 -->
                <el-form-item style="width:8%">
                    <el-select v-model="query.isground" filterable clearable @change="changesearch" placeholder="上下架">
                        <el-option v-for="(item,index) in groudlists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 库存状态 -->
                <el-form-item style="width:10%" v-if="isinventorywarn">
                    <el-select v-model="query.isinventorywarn" filterable clearable @change="changesearch" placeholder="是否库存充足">
                        <el-option v-for="(item,index) in warnlists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item style="width:11%">
                    <el-select v-model="query.brandid" clearable remote  filterable placeholder="按品牌" @change="changesearch">	            
                        <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                            <span style="float: left">{{item.name}}</span>
                            <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                        </el-option>              
                    </el-select>          
                </el-form-item>

                <el-form-item>
					<el-select v-model="query.shippingtempidid" clearable remote  filterable placeholder="请选择运费模板" @change="changesearch">
						<el-option v-for="(item,index) in shippingtemplists" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>

                <el-form-item>
                    <el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getList" @change="changesearch" style="width:100%"></el-input>
                </el-form-item>
                <el-form-item v-if="wangdian_sid">
                    <el-select v-model="query.has_thumb" clearable placeholder="是否有封面图片" @change="changesearch">
						<el-option label="全部" value="0"></el-option>
						<el-option label="有" value="1"></el-option>
						<el-option label="没有" value="2"></el-option>
					</el-select>
                </el-form-item>
                <!-- 利润率 -->
                <el-form-item style="width:25%" v-if="query.parentagentid==100000">
                    <template slot-scope="scope">
                        <el-input placeholder="最小利润率" v-model="query.percentlow" clearable @change="changesearch" style="width:47%"><template slot="append">%</template></el-input> ~
                        <el-input placeholder="最大利润率" v-model="query.percentheight" clearable @change="changesearch" style="width:47%"><template slot="append">%</template></el-input>
                    </template>
                </el-form-item>
                <el-form-item>
                    <el-button type="warning" @click="getList">查询</el-button>
                </el-form-item>
                <!--
                <el-form-item>
                    <el-button type="primary" icon="el-icon-share"  @click="sharecode">分享</el-button>
                </el-form-item>
                -->
                <!--
                <el-form-item>
                    <el-button type="warning"  @click="getspecial">专区管理</el-button>
                    <el-button type="warning"  @click="getspecial">一件代发设置管理</el-button>
                </el-form-item>
                -->
                <el-form-item>
                    <el-button type="warning"  @click="exportgoods">导出商品</el-button>
                </el-form-item>
                <el-form-item v-if="isjdshow==true">
                    <el-button type="warning"  @click="exportmoresyndata">导出同步记录</el-button>
                </el-form-item>
                <el-form-item  v-if="datacenter!='cz' && !wangdian_sid">
                    <el-button type="warning"  @click="pushgoodsnocz">发布商品</el-button>
                </el-form-item>
                <el-form-item>
                    <el-badge :value="shippingtemps.length > 0 ? shippingtemps.length : ''" class="item">
                    <el-button type="warning"  @click="settingshippingmore">批量设置运费模板</el-button>
                    </el-badge>
                </el-form-item>
                <!--
                <el-form-item>
                    <el-tooltip class="item" effect="dark" content="仅用于第三方非宠赞进销存系统的库存数据同步" placement="top">
                        <el-button type="warning"  @click="sysgoodsinventorymore">批量同步商品库存</el-button>
                    </el-tooltip>
                </el-form-item>
                -->
                <el-form-item>
                    <el-button type="warning"  @click="editBatchGoods">批量修改商品信息</el-button>
                </el-form-item>
                <el-form-item  v-if="datacenter!='cz'">
                    <el-button type="warning"  @click="editinventorymore">批量修改商品库存</el-button>
                </el-form-item>
                <el-form-item >
                    <el-badge :value="shippingtemps.length > 0 ? shippingtemps.length : ''" class="item">
                        <el-button type="warning"  @click="statusChange(1)">批量上下架商品</el-button>
                    </el-badge>
                </el-form-item>
                <el-form-item>
                    <el-badge :value="shippingtemps.length > 0 ? shippingtemps.length : ''" class="item">
                        <el-button type="warning"  @click="statusChange(2)">批量上下架跑店小程序商品</el-button>
                    </el-badge>
                </el-form-item>

                <el-form-item>
                    <el-button type=""  @click="clearselectgoods">清除选中商品</el-button>
                </el-form-item>
                <el-form-item v-if="wangdian_sid">
                    <el-button type="warning" @click="wangdianSynchronous">旺店通商品同步</el-button>
                    <el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="wangdiantongSwitch" :active-value="1" :inactive-value="0" @change="wangdianChange"></el-switch>
                    <el-tooltip effect="dark" placement="right">
                      <div slot="content">开关打开：旺店通修改的数据同步到宠赞<br/>开关关闭：旺店通修改的数据不同步到宠赞</div>
                      <i class="el-icon-question" style="position: relative;top: -5px; color:#e6a23c;"></i>
                    </el-tooltip>
                </el-form-item>
            </el-form>

            <!-- 库存预警数量 -->
            <div style="margin-left:1%;position:relative;padding:15px 0" v-if="isinventorywarn">
                <span style="font-size:13px;position:relative;">设置库存预警数量： </span>
                <div style="position:relative;width:5%;display:inline-block;padding:5px 0">
                <el-badge :value="ishaveinventorywarn==0 ? '' : '预警商品数量：'+ishaveinventorywarn " class="item">
                <el-tooltip class="item" effect="dark" content="低于或等于该数量的商品将被视库存不足预警商品" placement="top">
                <el-input type="text" v-model="inventorywarnnumber" size="small" @blur="changeinventorywarn"/>
                </el-tooltip>
                </el-badge>
                </div>
            </div>

            <!-- 温馨提示 -->
            <div style="margin-top:10px;border-radius:5px;padding:.2rem 1% .2rem 1%;background:rgb(211,211,211,.2);border:1px solid rgba(221,221,221,.4)" v-if="jdmoneys.money > 0 && jdmoneys.money!=''">
                <span v-if="jdmoneys.money > 0 && jdmoneys.money!='' && jdmoneys.status==0"><em style="padding:.2rem .3rem;color:#fff;background:red;font-style:normal;color:#fff;font-size:.7rem;font-weight:bold;border-radius:50%">JD</em><i style="font-style:normal;color:#E6A23C;margin-left:1%;font-size:1rem;font-weight:bold">￥{{jdmoneys.money}}</i><i style="font-style:normal;margin-left:3px;normal;font-size:.7rem;color:rgb(144, 147, 153)">（京东预存款）</i></span>
                <span v-if="jdmoneys.money > 0 && jdmoneys.money!='' && jdmoneys.status==1"><em style="padding:.2rem .3rem;color:#fff;background:red;font-style:normal;color:#fff;font-size:.7rem;font-weight:bold;border-radius:50%">JD</em><i style="font-style:normal;color:red;margin-left:1%;font-size:1rem;font-weight:bold">￥{{jdmoneys.money}}</i><i style="font-style:normal;margin-left:3px;normal;font-size:.7rem;color:red">（京东预存款预警：预存款不足，请及时充值）</i></span>
            </div>

            <div style="margin-top:10px;margin-bottom:30px">
	        <el-table :data="lists" ref="goodsmultipleTable" v-loading="listLoading" @select="goodsselectchange" @select-all="goodsallselectchange">
              <el-table-column type="selection" width="30" align="center"></el-table-column>
              <el-table-column label="id" width="160" align="center">
                  <template slot-scope="scope">
                      <span style="float:left;width:100%">{{scope.row.id}}</span>
                      <span style="float:left;width:100%;font-size:12px;color:#909399" v-if="scope.row.sku!=null && scope.row.sku!=''">（{{scope.row.sku}}）</span>
                  </template>
              </el-table-column>
              <el-table-column label="商品信息" min-width="430">
                  <template slot-scope="scope">
                      <div class="goods-infos-main">  
                        <div class="goods-infos-type-jd" v-if="scope.row.ispropertyagent==1" style="margin:0;top:0;left:0;background:#e6a23c;border-radius:0 8px 8px 0;">
                            <img src="@/assets/Goods/share.png" style="width:18px;height:18px;"/>
                        </div>
                        <div class="goods-infos-type-jd" :style="scope.row.isgrounding==0 ? 'background:#e6a23c;width:18px;height:18px;right:0;bottom:0;border-radius:8px 0 0 8px;display:flex;justify-content:center;align-items:center' : 'background:#cccccc;width:18px;height:18px;right:0;bottom:0;border-radius:8px 0 0 8px;display:flex;justify-content:center;align-items:center' ">
                            <img :src="scope.row.isgrounding==0 ? require('@/assets/Goods/upground.png') : require('@/assets/Goods/downground.png')  " style="width:18px;height:18px;"/>
                        </div>
                        <img :src="scope.row.thumb=='' ? require('../../assets/img-default-2.jpg') : scope.row.thumb" class="cz-mall-goods"/>
                      </div>
                      <div class="goods-infos-name-main">

                        <el-tooltip class="item" effect="dark" :content="scope.row.name + (scope.row.spec!='' ? ' [ '+scope.row.spec+' ]' : '') + (scope.row.weight > 0 ? '，'+scope.row.weight+'kg' : '' ) " placement="top">
                        <span style="float:left;width:81%;margin-left:7%;font-size:13px;line-height:21px;overflow:hidden; text-overflow:ellipsis;white-space: nowrap;">
                            {{scope.row.name}}
                            <span style="font-size:12px;color:#999999;">
                            {{scope.row.spec!='' ? ' [ '+scope.row.spec+' ]' : ''  }}
                            {{scope.row.weight > 0 ? '，'+scope.row.weight+'kg' : '' }}
                            </span>
                        </span>
                        </el-tooltip>

                        <div class="cz-goods-brand-grant-out" style="float:left;width:81%;margin-left:7%;margin-top:10px;">
                        <el-tooltip class="item" effect="dark" :content="'品牌：'+scope.row.grantname" placement="top">
                        <img :src="scope.row.granttype==1 ? require('@/assets/Goods/grant.png') : require('@/assets/Goods/stop.png') " class="cz-goods-brand-grant-icon" />
                        </el-tooltip>
                        <span class="cz-goods-brand-grant-name">{{scope.row.brandname}}</span>
                        <a href="javascript:;" v-if="scope.row.agentname!=''"  class="cz-goods-brand-grant-btn" @click="editbrands(scope.row)">
                            <img src="@/assets/Goods/edit.png" />
                        </a>
                        </div>

                      </div>
                  </template>
              </el-table-column>

              <el-table-column label="使用运费模板" min-width="140" align="center">
                  <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" :content="scope.row.shippingtempname+'，'+scope.row.shippingtempmsg" placement="top">
                      <span style="float:left;font-size:12px;width:100%;overflow:hidden; text-overflow:ellipsis;white-space: nowrap;">{{scope.row.shippingtempname}}</span>
                      </el-tooltip>
                  </template>
              </el-table-column>

              <el-table-column label="批发价" align="center" key="showsellprice1" min-width="140">
                  <template slot-scope="scope">
                      <div>{{scope.row.showsellprice}}</div>
                  </template>
              </el-table-column>

              <el-table-column label="协议销售价"  align="center" min-width="130" key="jdcost1" v-if="this.query.parentagentid==100000">
                  <template slot-scope="scope">
                      <div style="float:left;width:100%;color:red">
                        {{scope.row.jdcostprice}}
                      </div>
                  </template>
              </el-table-column>

              <!-- 利润率 -->
              <el-table-column label="利润率（建议零售价-批发价）/建议零售价"  align="center" min-width="140" prop="percent1" v-if="this.query.parentagentid==100000" key="jdprofit"></el-table-column>
	          <el-table-column prop="isgrounding" label="上架"  align="center" min-width="130">
	          	<template slot-scope="scope">
	          	  	<el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="grounding[scope.$index]"  @change="changeGrounding(scope.$index,scope.row)" v-if="scope.row.isbrandidshow==0"></el-switch>              	                	  
	              	<el-tooltip class="item" effect="dark" content="该品牌商品已限制上架，请移步品牌管理选择线上商城展示进行开启" placement="top" v-if="scope.row.isbrandidshow==1">
                      <el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="grounding[scope.$index]"  @change="changeGrounding(scope.$index,scope.row)" disabled></el-switch>			      	
                  </el-tooltip>
	          	</template>
	          </el-table-column>
              <el-table-column prop="istardy" label="跑店小程序上/下架"  align="center" min-width="140" v-if="datacenter=='cz'">
	          	  <template slot-scope="scope">
	              	  <el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="pdgrounding[scope.$index]"  @change="changepaodian(scope.$index,scope.row)"></el-switch>
	          	  </template>
	          </el-table-column>	          
	          <el-table-column label="操作" fixed="right" align="center" width="280" v-if="actionauth.mall_goods_edit=='true' || actionauth.mall_goods_del=='true'">
		            <template slot-scope="scope">
		            	<el-button type="warning" size="small" round @click="editCurrent(scope.row)" v-if="actionauth.mall_goods_edit=='true'">编辑</el-button>
                        <el-button type="warning" size="small" round @click="editgoodslogs(scope.row)">编辑记录</el-button>
		            	<el-button type="" size="small" round @click="delCurrent(scope.row)" v-if="actionauth.mall_goods_del=='true'">删除</el-button>
		            </template>
	          </el-table-column>
	        </el-table>
	        <div class="block">
	        <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	        </div>
            </div>
      </div>

      <div class="backborder1" v-if="searchtype==2">
            <el-form :inline="true" class="demo-form-inline" size="small" style="margin-top:10px">
                <!-- 是否有库存 -->
                <el-form-item style="width:8%">
                    <el-select v-model="skuquery.hasinventory" filterable clearable @change="skuquery.ischange=true" placeholder="是否有库存">
                        <el-option v-for="(item,index) in hasinventorylists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 是否是分销商品 -->
                <el-form-item style="width:8%" v-if="issplit==true">
                    <el-select v-model="skuquery.splitid" filterable clearable @change="skuquery.ischange=true" placeholder="分销商品">
                        <el-option v-for="(item,index) in splitlists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 是否上下架 -->
                <el-form-item style="width:8%">
                    <el-select v-model="skuquery.isground" filterable clearable @change="skuquery.ischange=true" placeholder="上下架">
                        <el-option v-for="(item,index) in groudlists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="width:11%">
                    <el-select v-model="skuquery.brandid" clearable remote  filterable placeholder="按品牌" @change="skuquery.ischange=true">	            
                        <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                            <span style="float: left">{{item.name}}</span>
                            <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                        </el-option>              
                    </el-select>          
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入关键字" v-model="skuquery.key" clearable @keyup.enter.native="getListfromsku" @change="skuquery.ischange=true" style="width:100%"></el-input>
                </el-form-item>
                <el-form-item v-if="wangdian_sid">
                    <el-select v-model="skuquery.has_thumb" clearable placeholder="是否有图片" @change="skuquery.ischange=true">
						<el-option label="全部" value="0"></el-option>
						<el-option label="有" value="1"></el-option>
						<el-option label="没有" value="2"></el-option>
					</el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="warning" @click="getListfromsku">查询</el-button>
                </el-form-item>
            </el-form>
            <div style="margin-top:10px;margin-bottom:30px">
	        <el-table :data="skugoodslists" v-loading="skuquery.loading" key="sku2">
              <el-table-column label="id" min-width="150" align="left">
                  <template slot-scope="scope">
                      <span style="float:left;width:100%">{{scope.row.id}}</span>
                      <span style="float:left;width:100%;font-size:12px;color:#909399" v-if="scope.row.sku!=null && scope.row.sku!=''">sku：{{scope.row.sku}}</span>
                      <span style="float:left;width:100%;font-size:12px;color:#909399" v-if="scope.row.sku!=null && scope.row.sku!=''">spu：{{scope.row.sku}}</span>
                  </template>
              </el-table-column>
              <el-table-column label="商品信息" min-width="300">
                  <template slot-scope="scope">
                      
                      <div class="goods-infos-main">
                        <div class="goods-infos-type-jd" v-if="scope.row.isagent==1" style="margin:0;top:0;left:0;background:#e6a23c;border-radius:0 8px 8px 0;">
                            <img src="@/assets/Goods/share.png" style="width:18px;height:18px;"/>
                        </div>
                        <div class="goods-infos-type-jd" :style="scope.row.isgrounding==0 ? 'background:#e6a23c;width:18px;height:18px;right:0;bottom:0;border-radius:8px 0 0 8px;display:flex;justify-content:center;align-items:center' : 'background:#cccccc;width:18px;height:18px;right:0;bottom:0;border-radius:8px 0 0 8px;display:flex;justify-content:center;align-items:center' ">
                            <img :src="scope.row.isgrounding==0 ? require('@/assets/Goods/upground.png') : require('@/assets/Goods/downground.png')  " style="width:18px;height:18px;"/>
                        </div>
                        <img :src="scope.row.thumb=='' ? require('../../assets/img-default-2.jpg') : scope.row.thumb" class="cz-mall-goods"/>
                      </div>

                      <div class="goods-infos-name-main">
                          <el-tooltip class="item" effect="dark" :content="scope.row.goodsname + (scope.row.spec!='' ? ' ['+scope.row.property_name+']' : '') + (scope.row.weight > 0 ?  ' ，'+scope.row.weight+'kg' : '')" placement="top">
                          <span style="float:left;width:82%;margin-left:7%;font-size:13px;line-height:21px;overflow:hidden; text-overflow:ellipsis;white-space: nowrap;">
                              {{scope.row.goodsname}}
                              <span style="font-size:12px;color:#999999;">
                                  {{scope.row.spec!='' ? ' ['+scope.row.property_name+']' : ''}} 
                                  {{scope.row.weight > 0 ?  ' ，'+scope.row.weight+'kg' : ''}}
                              </span>
                          </span>
                          </el-tooltip>

                          <div class="cz-goods-brand-grant-out" style="float:left;width:82%;margin-left:7%;margin-top:10px;">
                          <el-tooltip class="item" effect="dark" :content="'品牌：'+scope.row.grantname" placement="top">
                          <img :src="scope.row.granttype==1 ? require('@/assets/Goods/grant.png') : require('@/assets/Goods/stop.png') " class="cz-goods-brand-grant-icon" />
                          </el-tooltip>
                          <span class="cz-goods-brand-grant-name">{{scope.row.agentbrandname ? scope.row.agentbrandname : '无品牌'}}</span>
                          </div>

                      </div>
                  </template>
              </el-table-column>
              <!--
              <el-table-column label="品牌" min-width="130">
                  <template slot-scope="scope">
                      <div class="cz-goods-brand-grant-out">
                      <el-tooltip class="item" effect="dark" :content="scope.row.grantname" placement="top">
                      <img :src="scope.row.granttype==1 ? require('@/assets/Goods/grant.png') : require('@/assets/Goods/stop.png') " class="cz-goods-brand-grant-icon" />
                      </el-tooltip>
                      <span class="cz-goods-brand-grant-name">{{scope.row.agentbrandname ? scope.row.agentbrandname : '无品牌'}}</span>
                      </div>
                  </template>
              </el-table-column>
              -->
              <el-table-column label="批发价" min-width="130" align="center">
                  <template slot-scope="scope">
                      <div>{{scope.row.property_price}} / {{scope.row.unit}}</div>
                  </template>
              </el-table-column>
              <el-table-column label="重量（kg）" min-width="130" align="center">
                  <template slot-scope="scope">
                      <div>{{scope.row.weight}}</div>
                  </template>
              </el-table-column>
              <el-table-column label="剩余库存" min-width="150" align="center">
                  <template slot-scope="scope">
                      <div>{{scope.row.inventorys}}</div>
                  </template>
              </el-table-column>
              <el-table-column label="可用库存（剩余库存-冻结库存）" min-width="150" align="center">
                  <template slot-scope="scope">
                      <div>{{scope.row.lastinventorys}}</div>
                  </template>
              </el-table-column>
            </el-table>
            <div class="block">
	        <!--分页begin-->
	          <el-pagination
	            @size-change="skupageSizeChange"
	            @current-change="skupageCurrentChange"
	            :current-page="skuquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="skuquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="skuquery.rows">
	          </el-pagination>
	          <!--分页end-->
	        </div>
            </div>
      </div>
      <!------------------------search end---------------------->

      <!------------------------add list---------------------->
      <el-dialog title="可发布商品列表" :visible.sync="createListDialog" width="90%" top="1vh">
          <el-form :inline="true" size="medium">
	          <el-form-item>
	              <el-select v-model="productquery.brandid" filterable clearable placeholder="按品牌" @change="goodsselect=true">
	              	  <el-option label="不选品牌" value="0"></el-option>
	              	  <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
	              </el-select>
	          </el-form-item>
	          <el-form-item ref="productquery" :model="productquery">
	              <el-input placeholder="请输入关键字" v-model="productquery.key" clearable @keyup.enter.native="getProductList" @change="goodsselect=true"></el-input>
	          </el-form-item>
	          <el-form-item>
	              <el-button type="primary" icon="el-icon-search" @click="getProductList">查询</el-button>
	          </el-form-item>
          </el-form>
          <el-table :data="productLists" v-loading="createListLoading">
	          <el-table-column prop="number" label="编号" width="140"></el-table-column>
	          <el-table-column prop="brandname" label="品牌" width="120"></el-table-column>
	          <el-table-column prop="name" label="名称"></el-table-column>
	          <el-table-column prop="spec" label="规格" width="180"></el-table-column>
	          <el-table-column label="操作" width="80" align="center">
		          <template slot-scope="scope">
		              <el-button type="primary" size="small" icon="el-icon-plus" circle @click="addCurrent(scope.row)"></el-button>
		          </template>
	          </el-table-column>
          </el-table>
          <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="pageProductSizeChange"
	            @current-change="pageProductCurrentChange"
	            :current-page="productquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="productquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="product_total_rows">
	          </el-pagination>
	          <!--分页end-->
          </div>
      </el-dialog>

      <!------------------------add---------------------->
        <el-dialog title="发布商品" :visible.sync="createDialog" top="1vh" width="75%">
            <el-form ref="create" :model="create" :rules="rules" label-width="100px" size="medium">
            	<el-col :span="23">
	            	<el-form-item label="商品名称" prop="name">
	                  <el-input v-model="create.name" class="input-with-select"></el-input>
	                </el-form-item>
            	</el-col>
            	<el-col :span="23">
            		<el-col :span="8">
	            		<el-form-item label="商品品类" prop="pettype">
		                    <el-select v-model="create.pettype" placeholder="请选择">
			                    <el-option label="狗狗" value="1"></el-option>
			                    <el-option label="猫猫" value="2"></el-option>
			                    <el-option label="猫狗通用" value="4"></el-option>
			                    <el-option label="小宠" value="3"></el-option>
			                    <el-option label="其它" value="9"></el-option>
		                    </el-select>
	                	</el-form-item>
            		</el-col>
                    <el-col :span="8">
		                <el-form-item label="商品分类" prop="catid">
		                    <el-cascader :options="mallcategorylist" v-model="create.catid"></el-cascader>
		                </el-form-item>
	                </el-col>
                	<el-col :span="8">
	                	<el-form-item label="默认规格" prop="spec"><el-input v-model="create.spec"></el-input></el-form-item>
	                </el-col>
            	</el-col>
              <el-col :span="23">
                      <el-col :span="8">
                          <el-form-item label="批发价" prop="sellprice">
                            <el-input v-model="create.sellprice"><template slot="append">元</template></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="零售价" prop="marketprice">
                            <el-input v-model="create.marketprice"><template slot="append">元</template></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="单位" prop="unitid">
                              <el-select v-model="create.unitid" placeholder="请选择" @change="changeaddunit">
                                <el-option v-for="(item,index) in goodsunitlists" :key="index" :label="item.unit" :value="item.id"></el-option>
                              </el-select>
                          </el-form-item>
                        </el-col>
              </el-col>				
            	<el-col :span="23">
	                <el-col :span="8">
		                <el-form-item label="国外品牌" prop="unit">
		                    <el-select v-model="create.isinternal" placeholder="请选择">
		                    	<el-option v-for="(item,index) in internals" :key="index" :label="item.name" :value="item.value"></el-option>
		                    </el-select>
		                </el-form-item>
	                </el-col>
                </el-col>

                <el-col :span="24" style="margin-top:20px">
                	<el-col :span="23">
              		    <el-form-item>
              		    	<el-col :span="24"><el-alert title="商品规格信息" type="success" :closable="false" style="line-height:20px"></el-alert></el-col>
	              			<el-table :data="allProperty" border style="width:100%;margin-top:10px" v-loading="createpropertyloading">
	                  			<el-table-column prop="id" label="编号" width="60" align="center"></el-table-column>
	                  			<el-table-column label="图片" align="center" width="80">
			                    <template slot-scope="scope">
			                        <el-input v-model="create.property_img[scope.$index]" style="display:none"></el-input>
			                        <div class="cateimg">
			                      		<input type="file" @change="filecateimgChange($event,scope.$index)"/>
			                        	<img :src="create.cateimglists[scope.$index]" v-if="create.cateimglists[scope.$index]!=''" />
			                        	<img src="../../static/images/no-img.png" v-if="create.cateimglists[scope.$index]==''" />
			                        </div>
			                    </template>
	                  		</el-table-column>
	                  		<el-table-column label="商品" align="center" width="95">
			                    <template slot-scope="scope">
			                  	    <el-input v-model="create.number[scope.$index]" placeholder="选择商品绑定" v-if="scope.$index == 0" :disabled="true"></el-input>
			                        <el-input v-model="create.number[scope.$index]" placeholder="选择商品绑定" @focus="chooseNumber(scope.$index)" v-if="scope.$index > 0"></el-input>
			                    </template>
	                  		</el-table-column>
			                <el-table-column label="属性名称" align="center">
			                  	<template slot-scope="scope">
			                  	  	<el-input v-model="create.property_name[scope.$index]" placeholder="如:蓝色"></el-input>
			                  	</template>
			                </el-table-column>
		                    <el-table-column label="属性规格" align="center" width="110">
		                  	    <template slot-scope="scope">
		                  	  	    <el-input v-model="create.property_spec[scope.$index]" placeholder="属性规格"></el-input>
		                  	    </template>
		                    </el-table-column>
		                    <el-table-column label="属性价格(元)" align="center" width="180">
		                  	    <template slot-scope="scope">
		                  	  	    <el-input v-model="create.property_price[scope.$index]" placeholder="属性价格"><template slot="append">元</template></el-input>
		                  	    </template>
		                    </el-table-column>
		                    <el-table-column label="操作" width="70" align="center">
		                  	    <template slot-scope="scope">
		                  	  	    <el-button type="primary" size="small" icon="el-icon-plus" circle @click="addPropertyProject" v-if="scope.$index == 0"></el-button>
		                  		    <el-button type="danger" size="small" icon="el-icon-delete" circle @click="delPropertyProject" v-if="scope.$index > 0"></el-button>
		                  	    </template>
		                    </el-table-column>
              			</el-table>
              		</el-form-item>
              	</el-col>
            </el-col>
            <el-col :span="24" style="margin-top:20px">
              <el-col :span="23">
                <el-form-item v-loading="uillUpdateImg">
                	<el-col :span="24"><el-alert title="商品详情信息" type="success" :closable="false" style="line-height:20px;"></el-alert></el-col>
                	<el-upload style="display:none" class="avatar-uploader"
                		:action="this.GLOBAL.uploadUrl"
                        :data="{ sys_type: 'cz', intranet_token:'Tzx9VY0OOGjUYZRb' }"
				        :show-file-list="false"
				        :on-success="createuploadSuccess"
				        multiple
				        :on-error="createuploadError"
				        :before-upload="createbeforeUpload">
				    </el-upload>	
                <quill-editor v-model="create.content"
                      ref="mycreateQuillEditor"
                    :options="editorOption"
                    @onEditorChange="onEditorchange($event)">
                </quill-editor>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24" style="margin-top:20px">
              <el-col :span="23">
                <el-form-item>	 
	                <template slot-scope="scope">
	                <el-col :span="24"><el-alert title="商品详情信息" type="success" :closable="false" style="line-height:20px;"></el-alert></el-col>                	               	                
	                <div id="app">
					    <div class="hello">
						    <div class="upload">      
							        <input @change="fileChange($event)" type="file" id="upload_file" multiple style="display: none">
							        <!-- 图片展示部分 -->
							        <div class="upload_warp_img">
								        <div class="upload_warp_img_div">
								          <div class="upload_warp_left" @click="fileClick"><img src="../../static/images/upload.png"></div>
								        </div>
								        <div class="upload_warp_img_div" v-for="(item,index) in imgList">
								          <div class="upload_warp_img_div_top">
								            <div class="upload_warp_img_div_text">
								              {{item.file.name}}
								            </div>
								            <img src="../../static/images/del.png" class="upload_warp_img_div_del" @click="fileDel(index)">
								        </div>
								        <img :src="item.file.src">
								    </div>
						        </div>
						    </div>
					    </div>
					</div>
                	</template>
	                
                </el-form-item>
              </el-col>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="createDialog = false">取 消</el-button>
              <el-button size="medium" type="primary" :loading="createLoading" @click="createSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------add end---------------------->

      <!------------------------选择商品编号 choose productid list---------------------->
        <el-dialog title="选择商品编号" :visible.sync="chooseListDialog" width="90%" top="1vh">
        <el-form :inline="true" size="medium">
          <!--
          <el-form-item>
            <el-select v-model="choose.brandid" clearable filterable placeholder="按品牌">
              <el-option label="不选品牌" value="0"></el-option>
              <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          -->
          <el-form-item>
	            <el-select v-model="choose.brandid" filterable clearable placeholder="按品牌" @change="goodsselect=true">
	              <el-option label="不选品牌" value="0"></el-option>
	              <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select>
	        </el-form-item>

          <el-form-item ref="choose" :model="choose">
            <el-input placeholder="请输入关键字" v-model="choose.key" clearable ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getChooseList">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="chooseLists" v-loading="chooseListLoading">
          <el-table-column prop="id" label="序号" width="120">
          </el-table-column>
          <el-table-column prop="number" label="商品编号" width="140">
          </el-table-column>
          <el-table-column prop="brandname" label="品牌" width="120">
          </el-table-column>
          <el-table-column prop="name" label="名称">
          </el-table-column>
          <el-table-column prop="spec" label="规格" width="140">
          </el-table-column>
          <el-table-column prop="sellprice" label="批发价" width="120">
          </el-table-column>
          <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="success" size="small" circle icon="el-icon-check" @click="chooseNumberSave(scope.row)"></el-button>
          </template>
          </el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageChooseSizeChange"
            @current-change="pageChooseCurrentChange"
            :current-page="choose.p"
            :page-sizes="[10, 20, 50]"
            :page-size="choose.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="choose_total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        </el-dialog>
        <!--------------------------choose productid end-------------------------------------->

        <!------------------------edit---------------------->
        <el-dialog title="编辑商品信息" :visible.sync="updateDialog" top="1vh" width="95%">
          <div style="float:left;width:100%;margin-bottom:30px;text-align:right">
            <el-button size="small" @click="updateDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
          </div>
          <el-form ref="update" :model="update" :rules="rules" label-width="100px" size="mini" class="mall-goods-base">
            <el-col :span="24" style="padding:0 0 20px 0;">
            <el-col :span="5">
            	<el-form-item label="商品名称" prop="name">
                    <el-input v-model="update.name" class="input-with-select"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="默认规格" prop="spec"><el-input v-model="update.spec"/></el-form-item>
            </el-col>
            <el-col :span="5">
	            <el-form-item label="商品品类" prop="pettype">
	                <el-select v-model="update.pettype" placeholder="请选择">
		                <el-option label="狗狗" value="1"></el-option>
		                <el-option label="猫猫" value="2"></el-option>
		                <el-option label="猫狗通用" value="4"></el-option>
		                <el-option label="小宠" value="3"></el-option>
		                <el-option label="其它" value="9"></el-option>
	                </el-select>
	            </el-form-item>
            </el-col>
            <el-col :span="5">
	            <el-form-item label="商品分类" prop="catid">
	                <el-cascader :options="mallcategorylist" v-model="update.catid" @change="changecatid"></el-cascader>
	            </el-form-item>
            </el-col>
            <el-col :span="5">
	            <el-form-item label="国外品牌" prop="unit">
	                <el-select v-model="update.isinternal" placeholder="请选择">
	                    <el-option v-for="(item,index) in internals" :key="index" :label="item.name" :value="item.value"></el-option>
	                </el-select>
	            </el-form-item>
            </el-col>
            <el-col :span="5">
	            <el-form-item label="批发价" prop="sellprice">
	                <el-input v-model="update.sellprice"><template slot="append">元</template></el-input>
	            </el-form-item>
            </el-col>
            <el-col :span="5">
	            <el-form-item label="零售价" prop="marketprice">
	                <el-input v-model="update.marketprice"><template slot="append">元</template></el-input>
	            </el-form-item>
            </el-col>
            <el-col :span="5">
	            <el-form-item label="特价" prop="specialprice">
	                <el-input v-model="update.specialprice"><template slot="append">元</template></el-input>
	            </el-form-item>
            </el-col>
            <!------------------- 特价开关关闭时候展示 -------------------->
            <!--
            <el-col :span="8">
	            <el-form-item label="单位" prop="unitid">
	                <el-select v-model="update.unitid" placeholder="请选择" @change="changeupdateunit">
	                    <el-option v-for="(item,index) in goodsunitlists" :key="index" :label="item.unit" :value="item.id"></el-option>
	                </el-select>
	            </el-form-item>
            </el-col>
            -->
            </el-col>
            
            <!--------- 设置商品标签 ----------->
            <el-col :span="24" style="margin-top:20px" v-if="this.labellists.length>0">
            	<el-col :span="23">
            		<el-form-item>
            			<el-col :span="24">
            				<el-alert title="商品标签信息" type="success" :closable="false" style="padding:10px 0 10px 0;line-height:20px"></el-alert>
            				<el-button type="primary" icon="el-icon-plus" circle size="small" @click="getlabellists" style="position:absolute;top:5px;right:10px"></el-button>
            			</el-col>
            			<template>
            				<el-col :span="24" style="border:1px solid #ebeef5;padding:2% 2% 2% 2%;">
            					<el-tag type="success" closable style="margin:0 10px 10px 0" v-for="(item,index) in update.labelids" :key="index" @close="delselectlabel(index)">{{item.name}}</el-tag>
            				</el-col>
            			</template>
            		</el-form-item>
            	</el-col>
            </el-col>
            
            <el-col :span="24" style="margin-top:20px;padding:20px 0 40px 0;border-top:1px dashed #C0C4CC;border-bottom:1px dashed #C0C4CC">
              <el-col :span="23">
                  <el-table :data="allUpdateProperty" class="goods-edit-infos" style="width:100%;margin-top:10px;margin-left:20px;" v-loading="createpropertyloading" size="mini">
	                  <el-table-column label="商品id" width="95" align="center">
	                      <template slot-scope="scope">
	                    	  <el-input v-model="update.number[scope.$index]" placeholder="选择商品绑定" v-if="scope.$index==0" :disabled="true"></el-input>
	                          <el-input v-model="update.number[scope.$index]" placeholder="选择商品绑定" @focus="chooseUpdateNumber(scope.$index)" v-if="scope.$index > 0"></el-input>
	                      </template>
	                  </el-table-column>
                      <el-table-column label="图片" align="center" width="70">
		                  <template slot-scope="scope">
		                      <el-input v-model="update.property_img[scope.$index]" style="display:none"></el-input>
		                      <div class="cateimg">
		                      	  <input type="file" @change="fileeditcateimgChange($event,scope.$index)"/>
		                          <img :src="update.cateimglists[scope.$index]" v-if="update.cateimglists[scope.$index]!=''" />
		                          <img src="../../static/images/no-img.png" v-if="update.cateimglists[scope.$index]==''" />
		                      </div>
		                  </template>
	                  </el-table-column>
	                  <el-table-column label="名称" width="150" align="center">
	                      <template slot-scope="scope">
	                          <el-input v-model="update.property_name[scope.$index]" placeholder="如:蓝色"></el-input>
	                      </template>
	                  </el-table-column>
	                  <el-table-column label="规格" width="100" align="center">
	                  	  <template slot-scope="scope">
	                  	  	  <el-input v-model="update.property_spec[scope.$index]" placeholder="属性规格"></el-input>
	                  	  </template>
	                  </el-table-column>
                      <el-table-column label="销售单位" width="100" align="center" prop="type">
	                  	  <template slot-scope="scope">
	                  	  	  <el-select v-model="update.unitids[scope.$index]" placeholder="请选择" @change="changeunits(scope.row,scope.$index)">
                                  <el-option v-for="(item,index) in update.unitlists[scope.$index]" :key="index" :label="item.unit" :value="item.id"></el-option>
                              </el-select>
	                  	  </template>
	                  </el-table-column>

	                  <el-table-column label="价格(元)" align="center" width="160">
	                  	  <template slot-scope="scope">
	                  	  	  <el-input v-model="update.property_price[scope.$index]" placeholder="属性价格"><template slot="append">元</template></el-input>
	                  	  </template>
	                  </el-table-column>
	                  <el-table-column label="特价(元)" align="center" width="160">
	                  	  <template slot-scope="scope">
	                  	  	  <el-input v-model="update.property_special[scope.$index]" placeholder="属性价格"><template slot="append">元</template></el-input>
	                  	  </template>
	                  </el-table-column>

                    <el-table-column label="代发价格" align="center" width="160" v-if="issplit==true">
		                  	<template slot-scope="scope">
		                  	  	<el-input v-model="update.property_isagentprice[scope.$index]" placeholder="请设置代发价格"><template slot="append">元</template></el-input>
		                  	</template>
		                </el-table-column>
                    <el-table-column label="商品重量" align="center" width="160" v-if="issplit==true">
		                  	<template slot-scope="scope">
		                  	  	<el-input v-model="update.property_weight[scope.$index]" placeholder="请设置代发价格"><template slot="append">kg</template></el-input>
		                  	</template>
		                </el-table-column>

						<el-table-column label="代发设置" align="center" width="100" v-if="issplit==true">
		                  	<template slot-scope="scope">
		                  	  	<el-tooltip class="item" effect="dark" content="开关开启时，表示该规格的商品允许宠老板系统商家代为销售（分销），反之不允许" placement="top">
					    			<el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="update.property_isagent[scope.$index]" ></el-switch>
		                  	    </el-tooltip>
							</template>
		                </el-table-column>

	                  <el-table-column label="操作" align="center">
		                  <template slot-scope="scope">
		                  	  <el-button type="primary" size="small" icon="el-icon-plus" circle @click="addUpdatePropertyProject" v-if="scope.$index == 0"></el-button>
		                  	  <el-button type="danger" size="small" icon="el-icon-delete" circle @click="delUpdatePropertyProject(scope.$index)" v-if="scope.$index > 0"></el-button>
		                  </template>
	                  </el-table-column>
	              </el-table>
              </el-col>
            </el-col>

            <el-col :span="24" style="margin-top:20px;padding:20px 0;" v-if="update.param.length > 0">
                <el-form-item>
                    <el-col :span="24" v-for="(item,index) in update.param" :key="index" style="padding:.5rem 1rem">
                        <el-col v-for="(tt,ii) in item" :key="ii" :span="6">{{tt}}</el-col>
                    </el-col>	
                </el-form-item>
            </el-col>
            
            <el-col :span="24" style="margin-left:20px;padding:20px 0;">
            	<el-col :span="23">
                    <el-upload
				            class="avatar-uploader"
				            :action="this.GLOBAL.uploadUrl"
                            :data="{ sys_type: 'cz', intranet_token:'Tzx9VY0OOGjUYZRb' }"
				            :show-file-list="false"
				            :on-success="edituploadSuccess"
				            multiple
				            :on-error="edituploadError"
				            :before-upload="editbeforeUpload">
				        </el-upload>	
       					<quill-editor v-model="update.content"
                			ref="myQuillEditor"
			                :options="editorOption"
                            v-loading="uillUpdateImg"
			                @onEditorChange="onEditorchange($event)">
  						</quill-editor>
     			</el-col>
            </el-col>
            
            <el-col :span="24" style="margin-top:20px;padding:40px 0;border-top:1px dashed #C0C4CC">
              <el-col :span="23">
                <div id="app" style="margin-left:20px">
					    <div class="hello">
						    <div class="upload">      
							        <input @change="fileChange($event)" type="file" id="upload_file" multiple style="display: none">
							        <!-- 图片展示部分 -->
							        <div class="upload_warp_img">
								        <div class="upload_warp_img_div">
								          <div class="upload_warp_left" @click="fileClick"><img src="../../static/images/upload.png"></div>
								        </div>
								        <div class="upload_warp_img_div" v-for="(item,index) in imgList">
								          <div class="upload_warp_img_div_top">
								            <div class="upload_warp_img_div_text">
								              {{item.file.name}}
								            </div>
								            <img src="../../static/images/del.png" class="upload_warp_img_div_del" @click="fileDel(index)">
								          </div>
								          <img :src="item.file.src">
								        </div>
						        	</div>
						    </div>
					    </div>
					</div>
              </el-col>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="updateDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------edit end---------------------->

      <!------------------------编辑时选择商品编号 choose productid list---------------------->
        <el-dialog title="选择商品编号" :visible.sync="chooseUpdateListDialog" width="90%" top="1vh">
        <el-form :inline="true" size="medium">
          
          <el-form-item style="width:11%">
          	  <el-select v-model="choose.brandid" clearable remote  filterable placeholder="按品牌">	            
                  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              	  	  <span style="float: left">{{item.name}}</span>
      				        <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                  </el-option>              
              </el-select>          
          </el-form-item>

          <el-form-item ref="choose" :model="choose">
            <el-input placeholder="请输入关键字" v-model="choose.key" ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getChooseList">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="chooseLists" v-loading="chooseListLoading">
          <el-table-column prop="id" label="序号" width="120">
          </el-table-column>
          <el-table-column prop="number" label="商品编号" width="140">
          </el-table-column>
          <el-table-column prop="brandname" label="品牌" width="120">
          </el-table-column>
          <el-table-column prop="name" label="名称">
          </el-table-column>
          <el-table-column prop="spec" label="规格" width="140">
          </el-table-column>
          <el-table-column prop="sellprice" label="批发价" width="120">
          </el-table-column>
          <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="success" size="small" circle icon="el-icon-check" @click="chooseUpdateNumberSave(scope.row)"></el-button>
          </template>
          </el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageChooseSizeChange"
            @current-change="pageChooseCurrentChange"
            :current-page="choose.p"
            :page-sizes="[10, 20, 50]"
            :page-size="choose.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="choose_total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        </el-dialog>
        <!--------------------------choose productid end-------------------------------------->
        
        <!------------------------  推荐专区管理  --------------------->
        <el-dialog title="推荐专区管理" :visible.sync="specialDialog" width="65%" top="5vh">
        	<el-tag type="danger">温馨提示：推荐专区里的商品排序越小越靠前</el-tag>
        	<el-form :inline="true" style="margin-top:10px" size="medium">
	            <el-form-item style="width:19%">
		            <el-select v-model="specialquery.brandid" clearable remote  filterable placeholder="按品牌" @change="specialbrandchange">
	          	  		<el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
	          		</el-select>      
	            </el-form-item>
	            <el-form-item style="width:19%">
		            <el-select v-model="specialquery.specialid" remote  filterable placeholder="按推荐位" @change="specialpchange">
	          	  		<el-option v-for="(item,index) in specialalls" :label="item.name" :value="item.id" :key="index"></el-option>
	          		</el-select>      
	            </el-form-item>
	            <el-form-item ref="choose" :model="choose">
		            <el-input placeholder="请输入关键字" v-model="specialquery.key" @change="specialkeychange"></el-input>
	            </el-form-item>
	            <el-form-item>
	            	<el-button type="primary" icon="el-icon-search" @click="getspeciallists">查询</el-button>
	            	<el-button type="danger" icon="el-icon-circle-plus" @click="addspecial">新增专区商品</el-button>
	            </el-form-item>
            </el-form>
            <el-table :data="specialists" v-loading="specialLoading">
	            <el-table-column prop="name" label="商品名称"></el-table-column>
	            <el-table-column label="排序" width="100" align="center">
	            	<template slot-scope="scope">
	            		<el-input size="small" v-model="specialists[scope.$index].newsort"  @blur="changesort(scope.row.id,scope.$index,specialquery.specialid)" v-if="specialquery.specialid==1"></el-input>
	            		<el-input size="small" v-model="specialists[scope.$index].specialsort"  @blur="changesort(scope.row.id,scope.$index,specialquery.specialid)" v-if="specialquery.specialid==2"></el-input>
	            		<el-input size="small" v-model="specialists[scope.$index].bannersort"  @blur="changesort(scope.row.id,scope.$index,specialquery.specialid)" v-if="specialquery.specialid==3"></el-input>
	            	</template>
	            </el-table-column>
	            <el-table-column label="操作" width="120" align="center">
		            <template slot-scope="scope">
		            	<el-button type="danger" size="small" icon="el-icon-delete" circle @click="delspecial(scope.row,specialquery.specialid)"></el-button>
		            </template>
	            </el-table-column>
	        </el-table>
	        <div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="specialpageSizeChange"
		            @current-change="specialpageCurrentChange"
		            :current-page="specialquery.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="specialquery.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="specialcount">
	            </el-pagination>
	            <!--分页end-->
        	</div>
        </el-dialog>
        
        
        <!------------------------  添加专区商品信息  --------------------->
        <el-dialog :title="addspecialname" :visible.sync="addspecialgoodsDialog" width="60%" top="5vh">
        	<el-form :inline="true" style="margin-top:10px" size="medium">
	            <el-form-item style="width:19%">
		            <el-select v-model="addspecialquery.brandid" clearable remote  filterable placeholder="按品牌" @change="specialgoodsselect=true">
	          	  		<el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
	          		</el-select>      
	            </el-form-item>
	            <el-form-item ref="choose" :model="choose">
		            <el-input placeholder="请输入关键字" v-model="addspecialquery.key" @change="specialgoodsselect=true"></el-input>
	            </el-form-item>
	            <el-form-item>
	            	<el-button type="primary" icon="el-icon-search" @click="getaddspecial">查询</el-button>
	            </el-form-item>
            </el-form>
        	<el-table ref="multipleTable" :data="specialgoodslists" v-loading="specialgoodsLoading" @row-click="selectrow" @select="handleSelectsingle"  @select-all="handleSelectall">
        		<el-table-column type="selection" width="40"></el-table-column>
	            <el-table-column prop="name" label="商品名称"></el-table-column>
	            <el-table-column label="排序" width="100" align="center">
	            	<template slot-scope="scope">
	            		<el-input size="medium" v-model="specialgoodslists[scope.$index].newsort" @blur="setSelectionsorts(scope.row.id,specialgoodslists[scope.$index].newsort)"  v-if="addspecialquery.specialid==1"></el-input>
	            		<el-input size="medium" v-model="specialgoodslists[scope.$index].specialsort" @blur="setSelectionsorts(scope.row.id,specialgoodslists[scope.$index].specialsort)"  v-if="addspecialquery.specialid==2"></el-input>
	            		<el-input size="medium" v-model="specialgoodslists[scope.$index].bannersort" @blur="setSelectionsorts(scope.row.id,specialgoodslists[scope.$index].bannersort)"  v-if="addspecialquery.specialid==3"></el-input>
	            	</template>
	            </el-table-column>
	        </el-table>
	        <div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="specialgoodspageSizeChange"
		            @current-change="specialgoodspageCurrentChange"
		            :current-page="addspecialquery.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="addspecialquery.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="specialgoodscount">
	            </el-pagination>
	            <!--分页end-->
        	</div>
        	<div slot="footer" class="dialog-footer">
            	<el-button size="medium" @click="addspecialgoodsDialog = false">取 消</el-button>
            	<el-button size="medium" type="primary" :loading="addspecialgoodsLoading" @click="addspecialgoodsSave">保 存</el-button>
            </div>
        </el-dialog>
        
        
        <!--------------------------  分享二维码展示窗口  --------------------------------------------->
        <el-dialog title="微信扫码分享报价单" :visible.sync="codeDialog" width="20%">
            <qrcode-vue :value="codeurl" size="200" level="H" align="center"></qrcode-vue>
        </el-dialog>
		
		
		    <el-dialog title="选择商品标签列表" :visible.sync="labelDialog" width="45%" top="5vh">
        	  <div v-for="(item,index) in labellists" :key="index" style="border-color:#C0C4CC;padding:10px 2% 10px 2%;float:left;width:96%;margin-bottom:20px;border-radius:5px;background:rgb(221, 221, 221, 0.3)">
        	      <a href="javascript:;" @click="selectparentlabel(index)"><el-tag :type="item.type" style="float:left;">{{item.name}}</el-tag></a>
        	      <span style="margin:15px 0 15px 0;border-bottom:1px solid #fff;float:left;width:100%"></span>
        	      <div style="float:left;width:100%">
        	   	      <a href="javascript:;" @click="selectchildlabel(index,i)" v-for="(tt,i) in item.child" :key="i"><el-tag :type="tt.type" style="float:left;margin:0 10px 5px 0;" size="small">{{tt.name}}</el-tag></a>
        	      </div>
        	  </div>
        	<div slot="footer" class="dialog-footer">
              <el-button size="small" @click="labelDialog = false">取 消</el-button>
              <el-button size="small" type="primary" :loading="updateLoading" @click="savelabels">保 存</el-button>
            </div>
        </el-dialog>
        
        <!-------------------------- 导出线上商城商品信息 --------------------------------------------->
        <el-dialog title="导出商品信息" :visible.sync="exportDialog" width="80%" top="5vh">
            <div style="float:left;width:100%;margin-top:10px;overflow:hidden;" v-loading="exportloading">
                <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>

                <el-table :data="exportdata">
                    <el-table-column prop="id" label="id" />
                    <el-table-column prop="name" label="商品名称" />
                    <el-table-column prop="barcode" label="条形码" />
                    <el-table-column prop="spec" label="规格" />
                    <el-table-column prop="isgrounding" label="上下架" />
                    <el-table-column prop="marketprice" label="零售价" />
                    <el-table-column prop="price" label="批发价" />
                    <el-table-column prop="especially_price" label="活动到手价" />
                    <el-table-column prop="expire_at" label="有效期至"> 
                        <template slot-scope="scope">
                            <span>{{ scope.row.expire_at | formatDate }}</span>
                        </template>
                    </el-table-column>
	            </el-table>

	          </div>
            <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="exportDialog = false" style="margin-top:20px">取 消</el-button>
              <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-top:20px">确认导出</el-button>
            </div> 
        </el-dialog>


        <!----  修改商品品牌信息 --------->
        <el-dialog title="修改商品品牌信息" :visible.sync="editbrandDialog" width="20%" top="15vh">
            <el-select v-model="editbrandquery.brandid" filterable clearable placeholder="按品牌" size="mini">
	              <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="editbrandDialog = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="savegoodsbrand" :loading="editbrandloading">确 定</el-button>
            </div> 
        </el-dialog>

        <!-- 修改口号 -->
        <el-dialog title="修改口号信息" :visible.sync="sloganDialog" width="40%" top="10vh">
            <el-col :span="24"><el-button type="danger" size="mini" circle icon="el-icon-plus" @click="addsingleslogan" style="float:right"></el-button></el-col>
            <el-table :data="sloganquery.lists" size="mini">
                <el-table-column label="图标" align="center" width="80">
			              <template slot-scope="scope">
			                  <el-input v-model="scope.row.url" style="display:none"></el-input>
			                  <div class="cateimg">
			                    <input type="file" @change="filesloganChange($event,scope.$index)"/>
			                    <img style="width:1.5rem;height:1.5rem" :src="scope.row.img" v-if="scope.row.url!=''"/>
                          <img style="width:1.5rem;height:1.5rem" src="../../static/images/upload.png" v-if="scope.row.url==''"/>
                        </div>
			              </template>
	              </el-table-column>
                <el-table-column label="标语" align="center">
			              <template slot-scope="scope">
			                  <el-input v-model="scope.row.name" size="mini"></el-input>
			              </template>
	              </el-table-column>
                <el-table-column label="排序" align="center">
			              <template slot-scope="scope">
			                  <el-input v-model="scope.row.sort" size="mini"></el-input>
			              </template>
	              </el-table-column>
                <el-table-column label="操作" align="center">
			              <template slot-scope="scope">
			                  <el-button type="danger" size="mini" circle icon="el-icon-minus" @click="delsingleslogan(scope.$index)"></el-button>
			              </template>
	              </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="sloganDialog = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="saveslogan">确 定</el-button>
            </div> 
        </el-dialog>

        <!-- 价格信息提示 -->
		<el-dialog title="敏感信息提示" :visible.sync="shownoticeDialog" width="45%" top="15vh">
            <el-tag type="danger">温馨提示：以下为敏感数据，请仔细查看再确认</el-tag>
            <div style="float:left;width:100%;margin:10px 0 10px 0">
                <div style="float:left;width:100%;line-height:25px;margin-top:5px" v-for="(item,index) in shownotice" :key="index">
                  {{item}}
                </div>
            </div>
        	  <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="shownoticeDialog = false">取 消</el-button>
              <el-button size="small" type="primary" @click="updategoodsSave">保 存</el-button>
            </div>
        </el-dialog>


        <!-- 批量设置商品运费模板 -->
        <el-dialog title="批量设置商品运费模板" :visible.sync="settingshippingmoreDialog" width="20%" top="15vh">
            <el-select v-model="settingshippingidmore" clearable remote  filterable placeholder="请选择运费模板" size="small" v-loading="shippingtemploading">
				<el-option v-for="(item,index) in shippingtemplists" :key="index" :label="item.name" :value="item.id"></el-option>
			</el-select>
			<el-button type="primary" circle size="mini" icon="el-icon-refresh" @click="getshippingtemplists"></el-button>
            <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="settingshippingmoreDialog = false">取 消</el-button>
              <el-button size="small" type="primary" @click="updategoodsmoreshippingtemplate" :loading="settingshippingmoreloading">保 存</el-button>
            </div>
        </el-dialog>

        <!-- 商品修改记录 -->
        <Goodseditlogs v-model="editgoodsid" :view="editlogs" @finish="closeLogwindow"/>

        <!-- 批量修改商品信息 -->
        <el-dialog title="批量修改商品信息" :visible.sync="editBatchGoodsObj.dialog" width="60%" top="15vh">
            <input id="fileupload2" type="file" @change="importfileForInfo(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
            <div v-loading="editBatchGoodsObj.loading" style="display:inline-block;width:100%">
                <div style="display:inline-block;width:100%;">
                    <!-- <el-button size="small" round type="warning" @click="downloadedit">下载模板</el-button> -->
                    <el-button size="small" round type="warning" @click="uploadmodel('fileupload2')">上传模板</el-button>
                    <span style="display:inline-block;margin-left:10px;font-size:12px;color:#666666;">当前已上传商品：<i style="font-size:15px;font-weight:700;font-style:normal;color:red;">{{editBatchGoodsList.length}}</i> 个</span>

                    <el-button size="small" type="warning" @click="saveGoodsUpdate" style="float:right">保 存</el-button>
                    <el-button size="small" @click="editBatchGoodsObj.dialog = false" style="float:right;margin-right:10px;">取 消</el-button>
                </div>
                <div style="color: red;margin:10px">通过ID匹配更新，商品名称和规格名称不支持更新</div>
                <el-table :data="editBatchGoodsList" style="margin-top:20px;">
                    <el-table-column label="id" min-width="80" prop="property_id" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.property_id}}</span>
			            </template>
	                </el-table-column>
                    <el-table-column label="商品名称" min-width="250" prop="name" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.name}}</span>
			            </template>
	                </el-table-column>
                    <el-table-column label="规格" min-width="120" prop="spec" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.spec}}</span>
			            </template>
	                </el-table-column>
                    <el-table-column label="上下架" min-width="80" prop="is_grounding" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.is_grounding}}</span>
			            </template>
	                </el-table-column>
                    <el-table-column label="零售价" min-width="80" prop="market_price" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.market_price}}</span>
			            </template>
	                </el-table-column>
                    <el-table-column label="批发价" min-width="80" prop="sell_price" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.sell_price}}</span>
			            </template>
	                </el-table-column>
                    <el-table-column label="活动到手价" min-width="100" prop="especially_price" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.especially_price}}</span>
			            </template>
	                </el-table-column>
                    <el-table-column label="有效期至" min-width="120" prop="expire_at" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.expire_at}}</span>
			            </template>
	                </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editBatchGoodsObj.dialog = false">取 消</el-button>
                <el-button size="small" type="warning" @click="saveGoodsUpdate">保 存</el-button>
            </div>
        </el-dialog>


        <!-- 批量修改商品库存 -->
        <el-dialog title="批量修改商品库存" :visible.sync="editinventoryobj.dialog" width="60%" top="15vh">
            <input id="fileupload" type="file" @change="importfile(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
            <div v-loading="editinventoryobj.loading" style="display:inline-block;width:100%">
                <div style="display:inline-block;width:100%;">
                    <el-button size="small" round type="warning" @click="downloadedit">下载模板</el-button>
                    <el-button size="small" round type="warning" @click="uploadmodel('fileupload')">上传模板</el-button>
                    <span style="display:inline-block;margin-left:10px;font-size:12px;color:#666666;">当前已上传商品：<i style="font-size:15px;font-weight:700;font-style:normal;color:red;">{{goodsinventorys.length}}</i> 个</span>

                    <el-button size="small" type="warning" @click="saveinventoryupdate" style="float:right">保 存</el-button>
                    <el-button size="small" @click="editinventoryobj.dialog = false" style="float:right;margin-right:10px;">取 消</el-button>
                </div>
                <el-table :data="goodsinventorys" style="margin-top:20px;">
                    <el-table-column label="id" min-width="100" prop="id" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.id}}</span>
			            </template>
	                </el-table-column>
                    <el-table-column label="sku" min-width="100" prop="sku" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.sku}}</span>
			            </template>
	                </el-table-column>
                    <el-table-column label="商品" min-width="250" prop="name" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.name}}</span>
			            </template>
	                </el-table-column>
                    <el-table-column label="修改价格" min-width="120" prop="price" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.price}}</span>
			            </template>
	                </el-table-column>
                    <el-table-column label="修改库存" min-width="120" prop="inventory" align="center">
                        <template slot-scope="scope">
			                <span style="font-size:13px">{{scope.row.inventory}}</span>
			            </template>
	                </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editinventoryobj.dialog = false">取 消</el-button>
                <el-button size="small" type="warning" @click="saveinventoryupdate">保 存</el-button>
            </div>
        </el-dialog>



        <el-dialog title="上传进度" :visible.sync="updatequery.dialog" width="35%" top="25vh">
            <el-progress :percentage="updatequery.percent"  color="#e6a23c" />
        </el-dialog>

        <!-- 批量上下架商品/跑店商品 -->
        <el-dialog
            :title="currentStatusChangeType == 1 ? '批量上下架商品' : '批量上下架跑店小程序商品'"
            :visible.sync="statusDialogVisible"
            width="30%"
            >
            <!-- 表单内容 -->
            <el-form label-width="100px">
                <el-form-item label="操作类型">
                <el-radio-group v-model="statusChangeType">
                    <el-radio :label="1">上架</el-radio>
                    <el-radio :label="2">下架</el-radio>
                </el-radio-group>
                </el-form-item>
            </el-form>
            
            <!-- 弹窗底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="statusDialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="statusChangeLoading" @click="handleStatusChangeSubmit">确 定</el-button>
            </span>
        </el-dialog>
				
  </div>
  </transition>
</template>

<script src="../../vendor/vue2.2.2.js"></script>
<script>
import { VueEditor } from 'vue2-editor'
import { quillEditor } from 'vue-quill-editor'
import  QrcodeVue  from 'qrcode.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Goodseditlogs from '@/components/mall/shipping/goodseditlog' //商品修改记录

export default {
  props:['childdata'],
  components: {
    VueEditor,
    quillEditor,
    QrcodeVue,
    Goodseditlogs,
  },
  data () {
    return {
      wangdian_sid: '',
      wangdiantongSwitch: 1,
      actionauth:'', //功能权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Goods/index",
      lists:[],
      brandlists:[],
      categorylist:[],
      listLoading:false,
      query:{
        act:'listnews',
        token:this.$cookies.get('token'),
        brandid:'',
        has_thumb: '',
        key:'',
        datafrom:1,
        splitid:'',
        parentagentid:'',
        isground:'',
        percentlow:'',
        percentheight:'',
        isinventorywarn:'',
        shippingtemplateid:'',
        rollpage: 10, // 页大小
        p: 1
      },
      warnlists:[{id:1,name:'库存不足'},{id:2,name:'库存充足'}],
      groudlists:[{id:1,name:'上架'},{id:2,name:'下架'}],
      total_rows: 0,
      createDialog: false,
      createLoading: false,
      create: {
        act:'add',
        token:this.$cookies.get('token'),
        pettype:'1',
        name:'',
        spec:'',
        sellprice:'',
        marketprice:'',
        catid:[],
        number:[],
        property_name:[],
        property_price:[],
        property_spec:[],
        property_img:[],
        cateimglists:[],
        content:'',
        photo: [],
        productid:'',
        brandid:'',
        unit:'',
        unitid:'',
        isinternal:'1',
      },
      updateDialog:false,
      updateLoading:false,
      uillUpdateImg:false,
      update: {
        act:'edit',
        token:this.$cookies.get('token'),
        id:'',
        sku:'',
        pettype:'',
        name:'',
        spec:'',
        sellprice:'',
        marketprice:'',
        specialprice:'',
        propertysku:[],
        isspecial:'',
        catid:[],
        number:[],
        property_name:[],
        property_price:[],
        property_special:[],
        property_spec:[],
        property_img:[],
        property_isagentprice:[],
        property_isagent:[],
        property_weight:[],
        oldunitids:[],
        unitids:[],
        units:[],
        unitlists:[],
        cateimglists:[],
        content:'',
        param:[],
        photo: [],
        phototype:[],
        productid:'',
        brandid:'',
        unit:'',
        unidid:'',
        isinternal:'',
        editorOption:[],
        labelids:[],
        type:'',
      },
      rules: {
        name: [
            { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
        sellprice: [
            { pattern:/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/, message: '应收款只能为数值'}
        ],
        marketprice: [
            { pattern:/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/, message: '应收款只能为数值'}
        ]
      },
      grounding:[],
      tardy:[],
      pdgrounding:[],
      createListDialog:false,
      createListLoading:false,
      productLists:[],
      productquery:{
        act:'productlists',
        token:this.$cookies.get('token'),
        brandid:'',
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      product_total_rows:0,
      propertyi:1,
      allProperty: [],
      dialogImageUrl: '',
      dialogVisible: false,
      unitlists:[],
      goodsunitlists:[],
      choose:{
        act:'chooselists',
        sku:'',
        propertysku:[],
        token:this.$cookies.get('token'),
        productid:'',
        brandid:'',
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      chooseListDialog:false,
      chooseListLoading:false,
      useCustomImageHandler:true,
      choose_total_rows:0,
      chooseLists:[],
      chooseIndex:0,
      updatepropertyi:1,
      allUpdateProperty: [],
      chooseUpdateIndex:0,
      chooseUpdateListDialog:false,
      internals:[
      	  {value:'1',name:'否'},
      	  {value:'2',name:'是'}
      ],
      exportdata:[],
      exportDialog:false,
      exportloading:false,


      editorOption: { //文本框功能配置
		  placeholder: '请输入内容',
		  modules: { // 配置富文本
			toolbar: {
				container: [
					['bold', 'italic', 'underline', 'strike'],
					['blockquote', 'code-block'],
					[{ 'header': 1 }, { 'header': 2 }],
					[{ 'direction': 'rtl' }],
					[{ 'size': ['small', false, 'large', 'huge'] }],
					[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
					[{ 'color': [] }, { 'background': [] }],
					[{ 'font': [] }],
					[{ 'align': [] }],
					['clean'],
					['link', 'image', 'video']
				],
				handlers: {
					'image': function(value) {
						if(value) {
							document.querySelector('.avatar-uploader input').click();
						}else {
							this.quill.format('image', false);
						}
					}
				},
			},
		  }
	  },
	  
	  mallcategorylist:[],
	  goodsselect:false,
	  
	  /** 生成二维码相关 **/
	  codeDialog:false,
	  codeurl:'',
	  
	  isquerychange:false,
	  imgList:[],
	  size:0,
	  imgphotolists:[],
	  imgtype:[],
	  uploadimgnumber:0,
	  uploadimglists:[],
	  createpropertyloading:false,
	  specialDialog:false,
	  
	  specialquery:{
        act:'speciallists',
        token:this.$cookies.get('token'),
        brandid:'',
        specialid:'1',
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      specialalls:[{id:'1',name:'新品'},{id:'2',name:'特价'},{id:'3',name:'品牌'}],
      specialists:[],
      specialcount:0,
      specialLoading:false,
      specialchange:false,
      addspecialgoodsDialog:false,
      addspecialname:'',
      addspecialquery: {
      	act:'specialinventory',
      	token:this.$cookies.get('token'),
        brandid:'',
        specialid:'1',
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      specialgoodscount:0,
      specialgoodslists:[],
      specialgoodsstatus:[],
      specialgoodsLoading:false,
      addspecialgoodsLoading:false,
      multipleSelection:[],
      specialgoodsselect:false,
      tagshow:'true',
      csstop: {'margin-top':'10px'},
      isjdshow:false,
      brandquery: {
	  	  act:'lists',
          token:this.$cookies.get('token'),
          jdshow:0,
          rollpage:100000
	  },
	  datafrom:[{id:1,name:'宠赞'},{id:2,name:'京东'}],
      splitlists:[{id:1,name:'是'},{id:2,name:'否'}],
	  labellists:[],
	  labelDialog:false,
	  updateLoading:false,
	  oldcatid:[],
    jdmoneys:[],
    issplit:false,
    saleagents:[],
    
    editbrandDialog:false,
    editbrandloading:false,
    editbrandquery: {
        act:'savegoodsbrands',
        id:'',
        brandid:'',
        token:this.$cookies.get('token')
    },
    slogan:[],
    sloganDialog:false,
    sloganquery: {
      'act':'setagentslogan',
      token:this.$cookies.get('token'),
      lists:[]
    },
    mallsloganlists:[],
    shownotice:[],
    shownoticeDialog:false,
    datacenter:'',
    agentlists:[],
    isinventorywarn:false,
    inventorywarnnumber:0,
    ishaveinventorywarn:false,

    searchtype:1,
    searchtypelists:[{id:1,name:'按spu显示'},{id:2,name:'按sku显示'}],
    skuquery: {
        act:'searchgoods_from_sku',
        token:this.$cookies.get('token'),
        has_thumb: '',
        hasinventory:'',
        splitid:'',
        isground:'',
        brandid:'',
        key:'',
        p:1,
        rollpage:10,
        loading:false,
        ischange:false,
        rows:0,
    },
    skugoodslists:[],
    hasinventorylists:[{id:1,name:'有库存'},{id:2,name:'无库存'}],
    shippingtemploading:false,
    shippingtemplists:[],
    shippingtemps:[],
    settingshippingmoreDialog:false,
    settingshippingidmore:'',
    settingshippingmoreloading:false,

    editlogs:false,
    editgoodsid:'',
    editBatchGoodsObj: {
        act:'getgoodsinventory',
        token:this.$cookies.get('token'),
        dialog:false,
        loading:false,
    },
    editBatchGoodsList:[],
    editinventoryobj: {
        act:'getgoodsinventory',
        token:this.$cookies.get('token'),
        dialog:false,
        loading:false,
    },
    goodsinventorys:[],
    updatequery: {
        act:'updategoodsinventorys',
        token:this.$cookies.get('token'),
        dialog:false,
        rollpage:2, //一次修改数据条数
        page:'', //页数
        allpage:'', //总页数
        percent:'', //完成百分比
        obj:'', //定时器对象
        flag:false, //是否正在修改
        finish:false, //是否已处理完
        lists:[],  //参数
    },
    statusDialogVisible: false,
    statusChangeType: '',
    currentStatusChangeType: 1,
    statusChangeLoading: false,

      
    }
  },
    
  mounted(){  
    this.getactionauth();
    this.getJDshow(); //查询是否开启调用京东数据权限
    this.getSplitshow(); //查询是否开启分销数据权限
    this.changesearchtypes(1); //按照spu类型查看商品数据

    this.getmallCategoryList(); //获取线上商城的分类
    this.getpushurl();
    this.agentinternals(); //获取新国货活动的信息（新国货活动结束后删除，2019年1月2日删除）
    this.getjdlastmoney(); //获取京东进货备用金额
    this.getagents(); //获取当前在售商品的代理商信息
    this.getslogan(); //获取商城标语
    this.getagentcenter(); //获取代理商所使用的数据中心
    // this.getpushagentlists(); //获取可发布商品的供应商
    this.getisinventorywarn(); //获取当前代理商是否有库存预警的权限
    this.getshippingtemplists(); //获取运费模板信息
    this.getwangdianSynchronous() // 获取是否开启旺店通同步
    this.wangdiantongSwitch = +this.$cookies.get('wangdian_state')
  },

  watch: {
      childdata(val) {
        if(val.isgoodslists) { //触发商品信息获取详情
            this.getList();	
        }
      },
  },
  
  methods:{
    statusChange(type) {
        if(this.shippingtemps.length==0) {this.$message.error("请选择要批量设置的商品");return false;}
        this.statusChangeType = ''
        this.currentStatusChangeType = type
        this.statusDialogVisible = true
    },
    async handleStatusChangeSubmit() {
        console.log(this.shippingtemps, 'OOOOOOOOOOOOOOO')
        this.statusChangeLoading = true
        const res = await this.$axios({
            url: this.GLOBAL.domain+"Goods/batch_loading_and_unloading",
            method: 'post',
            data: {
                ids: this.shippingtemps.join(','),
                type: this.currentStatusChangeType,
                status: this.statusChangeType
            }
        })
        if(res.Result === 0) {
            this.$message.success('操作成功!')
            this.getList()
            this.clearselectgoods()
            this.statusDialogVisible = false

        }
        this.statusChangeLoading = false
    },
    // 获取旺店通按钮状态
    async getwangdianSynchronous() { 
        const res = await this.$axios({
            url: this.GLOBAL.domain+"agentErp/index",
            method: 'post',
            data: {
                act: 'get_wangdian_state'
            }
        })
        if(res.Result === 0) {
            this.wangdiantongSwitch = Number(res.Data.wangdian_state)
        }

    },
    async wangdianSynchronous() {
      const res = await this.$axios({
        url: this.GLOBAL.domain+"Goods/index",
        method: 'post',
        data: {
          act: 'syncWangdianGoods'
        }
      })
      if(res.Result === 0) {
        this.$message({
          message: '同步请求已提交，正在处理中，请稍后...',
          type: 'success'
        });
      }
    },
    async wangdianChange(val) {
      const res = await this.$axios({
        url: this.GLOBAL.domain+"Goods/index",
        method: 'post',
        data: {
          act: 'updateWangdianState',
          state: val
        }
      })
      if(res.Result === 0) {
        this.$message({
          message: `同步开关已${val == 1 ? '开启' : '关闭'}`,
          type: 'success'
        });
      }
    },
    // 格式化日期
    formatDate(data) {
        const date = new Date(data);
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        const formattedDate = `${yyyy}-${mm}-${dd}`;

        return formattedDate;
    },
    //  批量修改商品信息
    editBatchGoods() {
        this.editBatchGoodsObj.dialog = true;
        this.editBatchGoodsList = [];
    },

    /** 批量修改商品库存 **/
    editinventorymore() {
        this.editinventoryobj.dialog=true;
        this.goodsinventorys=[];
    },

    /** 下单模板【库存】 **/
    downloadedit() {
        location.href=this.url+'/act/getgoodsinventory/token/'+this.$cookies.get('token');
    },

    /** 下单模板【商品信息】 **/
    downloadeditForInfo() {
        location.href=this.url+'/act/getgoodsinventory/token/'+this.$cookies.get('token');
    },


    /** 上传模板 **/
    uploadmodel(id) {
        document.getElementById(id).click();
    },


    /** 更新、输入传入后台 **/
    saveinventoryupdate() {
        if(this.goodsinventorys.length==0) {this.$message.error('请上传商品信息');return false;}

        //设置数据
        this.updatequery.lists=this.goodsinventorys;
        //设置总页数
        this.updatequery.allpage=parseInt(this.goodsinventorys.length / this.updatequery.rollpage);
        this.updatequery.allpage=parseInt(this.updatequery.allpage) + ( parseInt(this.goodsinventorys.length % this.updatequery.rollpage) > 0 ? parseInt(1) : parseInt(0) );
        //初始化当前页数
        this.updatequery.page=0;
        //初始化百分比
        this.updatequery.percent=0;
        //是否正在修改
        this.updatequery.flag=false; 
        //是否已处理完
        this.updatequery.finish=false;

        //关闭定时器
        clearInterval(this.updatequery.obj); //关闭定时器

        //打开窗口
        this.updatequery.dialog=true;
        //加载定时器
        this.updatequery.obj=setInterval(this.sysgoodslist,2000); //打开定时器
    },


    //执行定时任务
    sysgoodslist() {
        if(this.updatequery.flag || this.updatequery.finish) return false;
        this.updatequery.flag=true;

        //提取数据
        let temps=[];
        let _this=this;
        let srollpage=this.updatequery.page;
        let erollpage=(parseInt(this.updatequery.page) + parseInt(1)) * this.updatequery.rollpage - parseInt(1);
        this.updatequery.lists.forEach(function(item,index) {
            if(index >= srollpage && index <= erollpage) {
                temps.push(item);
            }
        });

        var resource = this.$resource(this.url);
		resource.save({act:'save_goods_edit_from_upload',token:this.$cookies.get('token'),data:JSON.stringify(temps)}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
                alert(res.data.Message);
			}else{   
				this.updatequery.page++; //标记完成页数 
                this.updatequery.flag=false; //允许下一次数据修改
                this.getspeed(); //计算当前进度
			}
		}).catch((res) => {
			
		});
    },

    //计算完成进度
    getspeed() {
        let percent=parseInt(this.updatequery.page / this.updatequery.allpage * 100); //获取进度信息
        percent >= 100 ? percent=100 : '';
        this.updatequery.percent=percent;

        let _this=this;
        if(percent==100) {
            this.updatequery.finish; //标记完成状态
            setTimeout(function() { //延迟关闭完成任务
                clearInterval(_this.updatequery.obj); //关闭定时器
                _this.updatequery.dialog=false; //关闭loading窗口
                _this.editBatchGoodsObj.dialog=false; 
                _this.editinventoryobj.dialog=false; //关闭上传订单窗口
                _this.getList(); //刷新最新商品数据
            },200);
        }
    },



    /************** 编辑【库存】导入excel表格数据 **************/
    importfile(obj) {    
        this.editinventoryobj.loading=true;
    	let _this = this;
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file = event.currentTarget.files[0];             
        var rABS = false; //是否将文件读取为二进制字符串
        var f = this.file;
        var outdata;
        var reader = new FileReader();
        FileReader.prototype.readAsBinaryString = function(f) {
        	var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload').value = null;

                //组装数据
                _this.goodsinventorys=[];
                let sort=0;
                outdata.forEach(function(item,index) {
                    sort++;
                    if(item['商品编码']!='' || item['sku']!='' || item['商品名称']!='' || item['销售价格']!='' || item['当前库存']!='')
                    _this.goodsinventorys.push({sort:sort,id:item['商品编码'],sku:item['sku'],name:item['商品名称'],price:item['销售价格'],inventory:item['当前库存'] > 0 ? item['当前库存'] : 0});
                });
                _this.editinventoryobj.loading=false;
                           
            }
            reader.readAsArrayBuffer(f);
        }
        if(rABS) {
        	reader.readAsArrayBuffer(f);
            _this.editinventoryobj.loading=false;
        } else {
            reader.readAsBinaryString(f);
            _this.editinventoryobj.loading=false;
        }
    },
    /************* 编辑【库存】导入excel表格数据 *****************/


    /************** 编辑【商品信息】导入excel表格数据 **************/
    importfileForInfo(obj) {    
        this.editBatchGoodsObj.loading=true;
    	let _this = this;
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file = event.currentTarget.files[0];                
        var rABS = false; //是否将文件读取为二进制字符串
        var f = this.file;
        var outdata;
        var reader = new FileReader();
        FileReader.prototype.readAsBinaryString = function(f) {
        	var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload2').value = null;

                //组装数据
                _this.editBatchGoodsList=[];
                outdata.forEach(function(item) {
                    if(item['商品编码']!='' || item['商品名称']!=''|| item['规格']!=''){
                        _this.editBatchGoodsList.push({
                            property_id:item['id'],
                            spec: item['规格'],
                            name:item['商品名称'],
                            market_price:item['零售价'],
                            especially_price:item['活动到手价'],
                            sell_price:item['批发价'],
                            expire_at:item['有效期至'],
                            // expire_at:item['有效期至'] ? _this.formatDate(item['有效期至']) : '',
                            is_grounding: item['上下架'],
                        });
                    }
                });
                _this.editBatchGoodsObj.loading=false;
            }
            reader.readAsArrayBuffer(f);
        }
        if(rABS) {
        	reader.readAsArrayBuffer(f);
            _this.editBatchGoodsObj.loading=false;
        } else {
            reader.readAsBinaryString(f);
            _this.editBatchGoodsObj.loading=false;
        }
    },
    /************* 编辑【商品信息】导入excel表格数据 *****************/

    /** 【商品信息】更新、输入传入后台 **/
    saveGoodsUpdate() {
        if(this.editBatchGoodsList.length==0) {this.$message.error('请上传商品信息');return false;}
        let temps=[];
        this.editBatchGoodsList.forEach(function(item) {
            temps.push({...item});
        });
        temps.forEach(item => {
            item.is_grounding = item.is_grounding === '上架' ? 0 : 1;
        });
        var resource = this.$resource(this.url);
		resource.save({act:'goods_property_commit',token:this.$cookies.get('token'),json_data:JSON.stringify(temps)}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login');
                this.$message.error(res.data.Message);
			} else {
				this.$message.success('修改成功');
                this.editBatchGoodsObj.dialog=false;
                this.getList();
			}
		}).catch((res) => {
			
		});
    },


    /** 第三方批量一键同步商品库存信息 **/
    sysgoodsinventorymore() {
        this.$emit('listenchild',{name:'批量同步商品库存',url:'SysGoodsinventory',data:[]});
    },


    /** 获取商品的修改记录 **/
    editgoodslogs(item) {
        this.editlogs=true;
        this.editgoodsid=item.id;
    },

    /** 关闭窗口回传控制 **/
    closeLogwindow() {
        this.editlogs=false;
        this.editgoodsid='';
    },


    /** 清空已选中的商品信息 **/
    clearselectgoods() {
        this.shippingtemps=[];
        this.getList();  
    },
    

    /** 批量保存商品运费模板 **/
    updategoodsmoreshippingtemplate() {
        this.settingshippingmoreloading=true;
		var resource = this.$resource(this.url);
		resource.save({act:'savegoodsmoreshippingtemplates',token:this.$cookies.get('token'),templateid:this.settingshippingidmore,ids:this.shippingtemps.join(",")}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.settingshippingmoreloading=false;
			}else{   
				this.settingshippingmoreloading=false;  
                this.settingshippingmoreDialog=false;
                this.shippingtemps=[];    
                this.getList();             
			}
		}).catch((res) => {
			this.settingshippingmoreloading=false;
		});
    },

    /** 批量设置运费模板 **/
    settingshippingmore() {
        if(this.shippingtemps.length==0) {this.$message.error("请选择要批量设置的商品");return false;}
        this.settingshippingmoreDialog=true;
        this.settingshippingidmore='';
    },

    ////////////////////////////////////
    /** 勾选商品 **/
    goodsselectchange(val,row) {
        var number=this.shippingtemps.indexOf(row.id);
        number==-1 ? this.shippingtemps.push(row.id) : this.$delete(this.shippingtemps,number);

    },

    /** 勾选/取消勾选全部商品 **/
    goodsallselectchange(val) {
        var _this=this;
        var number=-1;
        if(val.length > 0) { //新增商品
            val.forEach(function(item,i) {
                number=_this.shippingtemps.indexOf(item.id);
                number==-1 ? _this.shippingtemps.push(item.id) : '';
            });

        }else { //删除商品
            this.lists.forEach(function(item,i) {
                number=_this.shippingtemps.indexOf(item.id);
                number > -1 ? _this.$delete(_this.shippingtemps,number) : '';
            });
        }
    },
    /////////////////////////////////////

    /** 获取运费模板信息 **/
	getshippingtemplists() {
		this.shippingtemploading=true;
		var resource = this.$resource(this.GLOBAL.domain+"Shippingarea/index");
		resource.save({act:'getshippingtemplistsnew',token:this.$cookies.get('token'),temptypelists:1,sort:1,p:1,rollpage:10000000}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
            this.shippingtemploading=false;
        }else{
                this.shippingtemplists = JSON.parse(Base64.decode(res.data.Data));   
				this.shippingtemploading=false;                   
                console.log(this.shippingtemplists, '运费模板信息');
			}
		}).catch((res) => {
			this.shippingtemploading=false;
		});
	},



    /** 修改搜索类型 **/
    changesearchtypes(id) {
        this.searchtype=id;
        if(id==1) {
            this.query.brandid='';
            this.query.key='';
            this.query.datafrom='';
            this.query.has_thumb='';
            this.query.splitid='';
            this.query.parentagentid='';
            this.query.isground='';
            this.query.percentlow='';
            this.query.percentheight='';
            this.query.isinventorywarn='';
            this.query.p=1;
            this.query.rollpage=10;
            this.getList();

        }else if(id==2) {
            this.skuquery.hasinventory='';
            this.skuquery.splitid='';
            this.skuquery.has_thumb='';
            this.skuquery.isground='';
            this.skuquery.brandid='';
            this.skuquery.key='';
            this.skuquery.p=1;
            this.skuquery.rollpage=10;
            this.skuquery.rows=0;
            this.skugoodslists=[];
            this.getListfromsku();

        }
    },


    /** 按sku查询在售商品信息 **/
    getListfromsku() {
        if(this.skuquery.ischange) {
            this.skuquery.p=1;
            this.skuquery.rollpage=10;
        }

        this.skuquery.loading=true;
        var resource = this.$resource(this.url);
	    resource.query(this.skuquery).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
                this.skuquery.loading=false;
		    }else{
		        this.skugoodslists = JSON.parse(Base64.decode(res.data.Data));

                //处理品牌授权信息
                this.skugoodslists.forEach(function(item,index) {
                    if(item.agentbrandname!='' && item.brandtype==1) item.grantname='未授权';
                    if(item.agentbrandname!='' && item.brandtype==2) item.grantname='已授权';
                    if(item.agentbrandname!='' && item.brandtype==3) item.grantname='授权失败';
                    if(item.agentbrandname!='' && item.brandtype==4) item.grantname='授权未开始';
                    if(item.agentbrandname!='' && item.brandtype==5) item.grantname='授权过期';
                    item.brandtype==2 ? item.granttype=1 : item.granttype=2; //显示图标（1、通过 2、未通过）
                });

                this.skuquery.rows=parseInt(res.data.count);
                this.skuquery.loading=false;
                if(this.skuquery.ischange) this.skuquery.ischange=false;
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
            this.skuquery.loading=false;
	    });

    },


    skupageSizeChange(val) {
        this.skuquery.rollpage = val;
        this.getListfromsku();
    },
    skupageCurrentChange(val) {
        this.skuquery.p = val;
        this.getListfromsku();
    },

    
    /** 获取是否存在库存预警商品 **/
    getishavewarninventory() {
        var resource = this.$resource(this.url);
	    resource.query({act:'getishaveinventorywarn',token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		    }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
                this.ishaveinventorywarn=result.ishaveinventorywarn;
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
    },


    /** 修改线上商城库存预警数量 **/
    changeinventorywarn() {
        var resource = this.$resource(this.GLOBAL.domain+'setting/index');
	    resource.query({act:'setinventorywarn',inventorywarn:this.inventorywarnnumber,token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		    }else{
		        this.getishavewarninventory();

                //重新刷新库存不足列表
                this.query.brandid='';
                this.query.key='';
                this.query.datafrom=''
                this.query.splitid='';
                this.query.parentagentid='';
                this.query.isground='';
                this.query.percentlow='';
                this.query.percentheight='';
                this.query.isinventorywarn=1;
                this.query.p=1;
                this.query.rollpage=10;
                this.getList(); 
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
    },


    /** 获取线上商城是否有库存预警的权限 **/
    getisinventorywarn() {
        var resource = this.$resource(this.GLOBAL.domain+'setting/index');
	    resource.query({act:'getinventorywarn',token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		    }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
                this.isinventorywarn=result.isinventorywarn==0 ? false : true;
                this.inventorywarnnumber=result.isinventorywarnnumber;
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
    },


    /** 获取可发布商品的供应商 **/
	// getpushagentlists() {
	// 	var resource = this.$resource(this.url);
	//     resource.query({act:'getpushagentlists',token:this.$cookies.get('token')}).then((res) => {
	// 	    if(res.data.Result>0){
	// 	        if(res.data.Result=='70001') this.$router.push('/login')
	// 	        this.$message.error(res.data.Message);
	// 	    }else{
	// 	        this.agentlists = JSON.parse(Base64.decode(res.data.Data));
	// 			this.agentlists.forEach(function(item,index) {item.id=Number(item.id)});
    //             if(this.agentlists.length==1) this.query.parentagentid=this.agentlists[0].id;
	// 	    }
	//     }).catch((res) => {
	//         this.$message.error(this.GLOBAL.errortext);
	//     });
	// },  


    /** 数据中心不在宠赞的代理商发布商品 **/
    pushgoodsnocz() {
        this.$emit('listenchild',{name:'商品信息发布详情',url:'Goodspushinfo',data:{act:'noczsavemallgoodsnew',agentid:this.$cookies.get('agentid'),noczgoodspushinfo:true}});
    },


    /** 获取代理商所使用的数据中心 **/
	getagentcenter() {
    this.wangdian_sid = this.$cookies.get('wangdian_sid');
		var resource = this.$resource(this.url);
	    resource.save({act:'getdatacenter',token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		    }else{
            var result = JSON.parse(Base64.decode(res.data.Data));
            this.datacenter=result.datacenter;
		    }
	    }).catch((res) => {
	            
	    });
	},


    //重置表单
    reset() {
        this.$refs.create.resetFields();
    },

   /** 修改口号 **/
   changeslogan() {
       this.sloganDialog=true;
       var resource = this.$resource(this.url);
	     resource.query({act:'getslogan',token:this.$cookies.get('token')}).then((res) => {
		     if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		     }else{
		        this.sloganquery.lists = JSON.parse(Base64.decode(res.data.Data));
		     }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
   },

   /** 添加口号 **/
   addsingleslogan(index) {
       this.sloganquery.lists.push({name:'',url:'',img:'',sort:''});
   },

   /** 删除口号 **/
   delsingleslogan(index) {
       this.sloganquery.lists.splice(index,1);
   },

   /** 编辑口号图片 **/
	 filesloganChange(obj,index) {
	    	var file=obj.target.files[0]; //获取文件信息
	    	var formData = new FormData();
	    	formData.append('file', file);
            formData.append('sys_type', 'cz');
            formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    	var resource = this.$resource(this.GLOBAL.uploadUrl);
	    	resource.save(formData).then((res) => {
		    	  var data=JSON.parse(Base64.decode(res.body.Data));
			      if(data.Result > 0) {
			    	    this.$message.error(data.msg);
			      }else {
		        	  this.sloganquery.lists[index].url=data.imgsrc;
		        	  this.sloganquery.lists[index].img=this.GLOBAL.staticUrl+data.imgsrc;       	
		        }
		    }).catch((res) => {
		        //this.$message.error(this.GLOBAL.errortext);
		    });
	 },


   /** 获取商城标语信息 **/
   getslogan() {
       var resource = this.$resource(this.url);
	     resource.query({act:'getagentnameandslogan',token:this.$cookies.get('token')}).then((res) => {
		     if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		     }else{
		        this.slogan = JSON.parse(Base64.decode(res.data.Data));
            this.mallsloganlists=this.slogan.sloganlists;
            this.sloganDialog=false;
		     }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
   },

   /** 保存商城标语信息 **/
   saveslogan() {
       var resource = this.$resource(this.url);
	     resource.save(this.sloganquery).then((res) => {
		     if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		     }else{
		        this.getslogan();
		     }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
   },

  /** 获取目前在售商品的代理商信息 **/
  getagents() {
      var resource = this.$resource(this.url);
	    resource.query({act:'getsaleagents',token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		    }else{
		        this.saleagents = JSON.parse(Base64.decode(res.data.Data));
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
  },  
    
  /** 查询是否开启调用京东商品数据权限 **/
	getJDshow() {
		  var resource = this.$resource(this.url);
	    resource.query({act:'getJDshow',token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		    }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
		        this.isjdshow=result.show;
		        if(result.show==0) this.getBrand(0);
		        if(result.show==1) this.getBrand(3);
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
	},

  /** 查看是否开启分销权限 **/
  getSplitshow() {
      var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
	    resource.query({act:'getsplit',token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
		    }else{
		        var result = JSON.parse(Base64.decode(res.data.Data));
                this.issplit=result.issplit;
		    }
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
  },
    
    /** 获取品牌 **/
	getBrand(isshow){
	    var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
	    resource.query(this.brandquery).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    this.brandlists = JSON.parse(Base64.decode(res.data.Data));
			}
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
	},
    
    /** 获取单位 **/
    getUnit(){
        var resource = this.$resource(this.url);
        resource.query({act:'getunit',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.unitlists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取分类列表 **/
    getCategoryList(){
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.categorylist = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    //获取线上商城分类列表
    getmallCategoryList(){
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({ act:'getmallcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.mallcategorylist = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 发布列表窗口 **/
    addListDialog(){
      this.$emit('listenchild',{name:'可发布商品',url:'Goodspush',data:{act:'editmallgoodsnew'}});
    },
    
    
    /** 信息列表 **/
    getProductList(){
    
      if(this.goodsselect==true) {
      	this.productquery.p=1;
      	this.productquery.rollpage=10;
      }
    
      this.createListLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.productquery).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.createListLoading = false;
        }else{
          this.productLists = JSON.parse(Base64.decode(res.data.Data));
          this.product_total_rows=parseInt(res.data.count);
          this.createListLoading = false;
        }
        
        if(this.goodsselect==true) this.goodsselect=false;
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.createListLoading=false;
          if(this.goodsselect==true) this.goodsselect=false;
      });
    },
    
    
    pageProductSizeChange(val) {
        this.productquery.rollpage = val;
        this.getProductList();
    },
    pageProductCurrentChange(val) {
        this.productquery.p = val;
        this.getProductList();
    },
    
    
    //信息列表
    getChooseList(){
      this.chooseListLoading = true;
      var resource = this.$resource(this.url);
      this.choose.productid=this.update.productid;
      this.choose.sku=this.update.sku;
      this.choose.productid=this.update.number[0];

      if(this.update.sku=='' || this.update.sku==null) {
          this.choose.act='chooselists';
      }else {
          this.choose.act='choosejdlists';
          this.choose.propertysku=this.update.propertysku;
      }

      resource.query(this.choose).then((res) => {
          if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.chooseListLoading = false;
          }else{
	          this.chooseLists = JSON.parse(Base64.decode(res.data.Data));
	          this.choose_total_rows=parseInt(res.data.count);
	          this.chooseListLoading = false;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.chooseListLoading=false;
      });
    },
    
    pageChooseSizeChange(val) {
        this.choose.rollpage = val;
        this.getChooseList();
    },
    pageChooseCurrentChange(val) {
        this.choose.p = val;
        this.getChooseList();
    },
    
    //选择属性价格产品编号
    chooseNumber(index){
      this.chooseIndex=index;
      this.getChooseList();
      this.chooseListDialog=true; 
    },
    
    chooseNumberSave(item){
      this.update.number.splice(this.chooseIndex,1,item.id);
      this.update.property_name.splice(this.chooseIndex,1,item.name);
      this.update.property_price.splice(this.chooseIndex,1,item.sellprice);
      this.update.property_spec.splice(this.chooseIndex,1,item.spec);
      this.update.property_special.splice(this.chooseIndex,1,0.00);
      if(item.imagePath!='') this.update.property_img.splice(this.chooseIndex,1,item.imagePath);
	  if(item.imagePath!='') this.update.cateimglists.splice(this.chooseIndex,1,item.imagePath);
	  if(item.imagePath!='') this.update.propertysku.splice(this.chooseIndex,1,item.number);	 
      this.chooseListDialog=false;
    },
    
    //发布界面
    addCurrent(item){    
      this.create.productid=item.id;
      this.create.brandid=item.brandid;
      this.create.name=item.name;
      this.create.spec=item.spec;
      this.create.catid=[];
      this.oldcatid=[];
      this.create.photo=[];
      this.imgphotolists=[];
      this.create.content='';
      this.imgList=[];
      
      this.allProperty=[];
      this.create.number=[];
      this.create.property_name=[];
      this.create.property_price=[];
      this.create.property_spec=[];
      this.create.property_img=[];
      this.create.property_img.length=[];
      this.create.cateimglists.length=[];

      //获取价格
      var resource = this.$resource(this.url);
      resource.save({ act:'getprice',id: item.id,token:this.$cookies.get('token')})
          .then((res) => {
          if(res.data.Result==0){
              var data=JSON.parse(Base64.decode(res.data.Data));
              //价格
              this.create.sellprice=data.sell;
              this.create.marketprice=data.market;
              this.create.unit=data.unit;
              
              //将产品本身作为一个默认必填规格，且不允许删除
		      this.propertyi++;
			  this.allProperty.push({id:this.propertyi});
		      this.create.number.push(item.id);
		      this.create.property_name.push(item.name);
		      this.create.property_price.push(data.sell);
		      this.create.property_spec.push(item.spec);
		      this.create.property_img.push('');
		      this.create.cateimglists.push('');  
          }
      }).catch((res) => {
          
      });
	
      this.getCategoryList();
      this.getUnitlists(item.id);
      this.createDialog=true;
    },
    addPropertyProject(){
      this.propertyi++;
      this.allProperty.push({id:this.propertyi});
      this.create.number.push('');
      this.create.property_name.push('');
      this.create.property_price.push('');
      this.create.property_spec.push('');
      this.create.property_img.push('');
      this.create.cateimglists.push('');
              
    },
    
    
    delPropertyProject(){
      this.propertyi--;
      this.allProperty.pop();
    },
    
    
    /** 添加商品规格 **/
    addUpdatePropertyProject(){
        this.updatepropertyi++;
        this.allUpdateProperty.push({id:this.updatepropertyi});
        
        this.update.number.push('');
        this.update.property_name.push('');
        this.update.property_price.push('');
        this.update.property_spec.push('');
        this.update.propertysku.push('');
		this.update.property_special.push('');
        this.update.property_img.push('');
        this.update.property_isagentprice.push('');
        this.update.property_isagent.push('');
        this.update.property_weight.push('');
        this.update.cateimglists.push('');
        this.update.unitids.push('');
        this.update.units.push('');
        this.update.oldunitids.push('');
        this.update.unitlists.push([]);
    },
    
    delUpdatePropertyProject(index){
        this.allUpdateProperty.splice(index,1);
        this.update.number.splice(index,1);
        this.update.property_name.splice(index,1);
        this.update.property_price.splice(index,1);
        this.update.property_spec.splice(index,1);
        this.update.propertysku.splice(index,1);
        this.update.property_special.splice(index,1);
        this.update.property_img.splice(index,1);
        this.update.property_isagentprice.splice(index,1);
        this.update.property_isagent.splice(index,1);
        this.update.property_weight.splice(index,1);
        this.update.cateimglists.splice(index,1);
        this.update.unitids.splice(index,1);
        this.update.units.splice(index,1);
        this.update.oldunitids.splice(index,1);
        this.update.unitlists.splice(index,1);
    },
    

    //发布前检测商品价格信息,并予以提示
    createSave() {
			this.createLoading=true;
			var resource = this.$resource(this.url);
			this.create.act='checkgoodsprice';
	        resource.save(this.create).then((res) => {
	            if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.createLoading=false;
	            }else{
	                var result = JSON.parse(Base64.decode(res.data.Data));
                  if(result.length > 0) {
                    this.shownotice=[];
                    this.shownotice=result;
                    this.shownoticeDialog=true;
                    this.createLoading=false;
                  }else {
                    this.createLoading=false;
                    this.goodsSave();
                  }
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	            this.createLoading=false;
	        });
		},

    //发布商品到线上商城
    goodsSave(){
			this.shownoticeDialog=false;
	        // 主动校验
	        this.$refs.create.validate((valid) => {
	            if(!valid) return false;
	            this.createLoading=true;
	            this.create.photo=this.imgphotolists; //获取上传的商品详情信息
	            this.create.phototype=this.imgtype;
	            
	            var resource = this.$resource(this.url);
				      this.create.act='add';
	            resource.save(this.create).then((res) => {
	                if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                    this.createLoading=false;
	                }else{
	                    this.$message.success(res.data.Message);
	                    this.createDialog=false;
	                    this.createLoading=false;
	                    this.getProductList();
	                }
	            }).catch((res) => {
	                this.$message.error(this.GLOBAL.errortext);
	                this.createDialog=false;
	                this.createLoading=false;
	            });
	        });
	  },

    
    /** 信息列表 **/
    getList(){
      this.listLoading = true;
      var resource = this.$resource(this.url);
      if(this.isquerychange==true) {
      	  this.query.p=1;
      	  this.query.rollpage=10;
      }
      
      resource.save(this.query).then((res) => {      
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          console.log('this.lists =====>', this.lists);
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
          if(this.isquerychange==true) this.isquerychange=false;

          //处理品牌授权信息
          this.lists.forEach(function(item,index) {
              if(item.brandname!='' && item.brandtype==1) item.grantname='未授权';
              if(item.brandname!='' && item.brandtype==2) item.grantname='已授权';
              if(item.brandname!='' && item.brandtype==3) item.grantname='授权失败';
              if(item.brandname!='' && item.brandtype==4) item.grantname='授权未开始';
              if(item.brandname!='' && item.brandtype==5) item.grantname='授权过期';
              item.brandtype==2 ? item.granttype=1 : item.granttype=2; //显示图标（1、通过 2、未通过）
          });
          
          var _this=this;
          setTimeout(function() {
            _this.lists.forEach(function(e,index){  
                e.isgrounding==0 ? _this.grounding.splice(index,1,true) : _this.grounding.splice(index,1,false);
                e.ispdgrounding==0 ? _this.pdgrounding.splice(index,1,true) : _this.pdgrounding.splice(index,1,false);
                e.istardy==0 ? _this.tardy.splice(index,1,false) : _this.tardy.splice(index,1,true);
                e.width="0px"; e.height="0px"; e.left="0px"; e.top="0px";

                _this.shippingtemps.indexOf(e.id) >=0 ? _this.$refs.goodsmultipleTable.toggleRowSelection(e) : '';

            });
          },200);  

        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    
    
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    //是否上架
    changeGrounding(index,item){
      if(this.grounding[index]){
        var isgrounding=0;
      }else{
        var isgrounding=1;
      }
      var resource = this.$resource(this.url);
      resource.save({act:'changegrounding',id:item.id,isgrounding:isgrounding,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001'){
              this.$router.push('/login')
            }
            this.$message.error(res.data.Message);
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    //是否开启允许欠货下单
    changeTardy(index,item){
    	var istardy=0;
        this.tardy[index] ? istardy=1 : istardy=0; 

        var resource = this.$resource(this.url);
        resource.save({act:'changetardy',id:item.id,istardy:istardy,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
            	this.$message.error(res.data.Message);
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },

    //上下架跑店小程序商品
    changepaodian(index,item) {
        var ispdgrounding=0;
        this.pdgrounding[index] ? ispdgrounding=0 : ispdgrounding=1; 

        var resource = this.$resource(this.url);
        resource.save({act:'pdgrounding',id:item.id,ispdgrounding:ispdgrounding,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
            	this.$message.error(res.data.Message);
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    //选择属性价格产品编号
    chooseUpdateNumber(index){
        this.chooseUpdateIndex=index;
        this.choose.productid=this.update.number[0];
        this.getChooseList();
        this.chooseUpdateListDialog=true;
    },
    
    chooseUpdateNumberSave(item){
      this.update.number.splice(this.chooseUpdateIndex,1,item.id);
      this.update.property_name.splice(this.chooseUpdateIndex,1,item.name);
      this.update.property_price.splice(this.chooseUpdateIndex,1,item.sellprice);
      this.update.property_spec.splice(this.chooseUpdateIndex,1,item.spec);
      this.update.property_special.splice(this.chooseUpdateIndex,1,0.00);
      if(item.imagePath!='') this.update.property_img.splice(this.chooseUpdateIndex,1,item.imagePath);
	  if(item.imagePath!='') this.update.cateimglists.splice(this.chooseUpdateIndex,1,item.imagePath);
	  if(item.imagePath!='') this.update.propertysku.splice(this.chooseUpdateIndex,1,item.number);
      
      //获取商品单位信息列表
      var resource = this.$resource(this.url);
      resource.save({ act:'getinfounits',id:item.id,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result > 0) {
            	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
            }else {
            	var data=JSON.parse(Base64.decode(res.data.Data));
            	this.update.unitids.splice(this.chooseUpdateIndex,1,data.unitid);
                this.update.units.splice(this.chooseUpdateIndex,1,data.unit);
                this.update.oldunitids.splice(this.chooseUpdateIndex,1,data.unitid);
                this.update.unitlists.splice(this.chooseUpdateIndex,1,data.unitlists);
            }
      }).catch((res) => {
            
      });

      this.chooseUpdateListDialog=false;
    },
    
    //编辑
    editCurrent(item){
        var data={agentid:item.type==1 ? 100000 : item.parentagentid,
                  goodspushinfo:true,
                  act:this.datacenter=='cz' ? 'editmallgoodsnew' : 'noczeditmallgoodsnew',
                  data:{goodsid:item.id,id:item.productid}
                 };
        this.$emit('listenchild',{name:'商品信息发布详情',url:'Goodspushinfo',data:data});
        return false;
        //下面操作忽略不计，已桥接到别处


    	let _this=this;
        this.update.id=item.id;
        this.update.sku=item.sku;
        this.update.name=item.name;
        this.update.pettype=item.pettype;
        this.update.spec=item.spec;
        this.update.sellprice=item.sellprice;
        this.update.marketprice=item.marketprice;
        this.update.catid=item.catid;
        this.oldcatid=item.catid;
        this.update.unitid=item.unitid > 0 ? item.unitid : '';
        this.update.unit=item.unit;
        this.update.unitids=[];
        this.update.oldunitids=[];
        this.update.units=[];
        this.update.param=item.param;
        this.update.type=item.type=='京东' ? 2 : 1;

        this.update.sellprice=item.sellprice;
        this.update.specialprice=item.specialprice;
        this.update.isspecial=item.isspecial;
        this.update.isinternal=item.isinternal;
        this.update.content=item.content;
        this.update.labelid=[];
        this.imgphotolists=[];
        this.imgList=[];
        this.imgtype=[];
        
        //清空商品属性分类信息
        this.update.number=[];
        this.update.propertysku=[];
        this.update.phototype=[];
        this.update.property_name=[];
        this.update.property_price=[];
        this.update.property_special=[];
        this.update.property_spec=[];
        this.update.property_img=[];
        this.update.property_isagentprice=[];
        this.update.property_isagent=[];
        this.update.property_weight=[];
        this.update.cateimglists=[];
        this.updatepropertyi=0;
        this.allUpdateProperty=[];
        
        //获取图片
        var resource = this.$resource(this.url);
        resource.save({ act:'getinfo',id: item.id,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result > 0) {
            	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            
            }else {
            	var data=JSON.parse(Base64.decode(res.data.Data));
            	//商品图片赋值
                if(data.photo.length > 0) {
                	data.photo.forEach(function(item,i) {
                		_this.imgphotolists.push(item.url);        		              		
                		_this.imgList.push({file:{src:item.file,name:item.name}});
                		_this.imgtype.push(item.type);
                	});
                }
                
                //商品规格
            	if(data.propertycounti > 0) {
                    this.updatepropertyi=data.propertycounti;
                    this.allUpdateProperty=data.propertycount;
                    
                    //组装分类信息
                    data.number.forEach(function(item,i) {
                    	_this.update.number.push(item);
                    	data.propertysku[i]!='' ? _this.update.propertysku.push(data.propertysku[i]) : _this.update.propertysku.push('');
                    	data.property_name[i]!='' ? _this.update.property_name.push(data.property_name[i]) : _this.update.property_name.push('');
                    	data.property_price[i]!='' ? _this.update.property_price.push(data.property_price[i]) : _this.update.property_price.push('');
                    	data.property_special[i]!='' ? _this.update.property_special.push(data.property_special[i]) : _this.update.property_special.push('');
                        data.property_isagent[i]!='' ? _this.update.property_isagent.push(data.property_isagent[i]) : _this.update.property_isagent.push('');
                        data.property_isagentprice[i]!='' ? _this.update.property_isagentprice.push(data.property_isagentprice[i]) : _this.update.property_isagentprice.push('');
                        data.property_weight[i]!='' ? _this.update.property_weight.push(data.property_weight[i]) : _this.update.property_weight.push('');
                        data.unitids[i] > 0 ? _this.update.unitids.push(data.unitids[i]) : _this.update.unitids.push('');
                        data.unitids[i] > 0 ? _this.update.oldunitids.push(data.unitids[i]) : _this.update.oldunitids.push('');
                        data.units[i]!='' ? _this.update.units.push(data.units[i]) : _this.update.units.push('');
                        
                    	data.property_spec[i]!='' ? _this.update.property_spec.push(data.property_spec[i]) : _this.update.property_spec.push('');	
                    	data.property_img[i]!='' ? _this.update.property_img.push(data.property_img[i]) : _this.update.property_img.push('');
					    data.property_img[i]!='' ? _this.update.cateimglists.push(data.property_img[i]) : _this.update.cateimglists.push('');		
                    }); 
                    this.update.unitlists=data.unitlists;  
                }

                //商品标签
                this.update.labelids=data.labelidlists;
                
            }
        }).catch((res) => {
            
        });

        item.type!='京东' ? this.getUnitlists(item.productid,item.sku) : '';
        this.getCategoryList();
        this.getcatlabel();
        this.updateDialog=true;
    },
    
    /** 获取商品单位（包括辅助单位） **/
    getUnitlists(id,sku) {
    	var resource = this.$resource(this.url);
        resource.query({act:'getunitlists',id:id,sku:sku,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.goodsunitlists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 修改商品单位信息 **/
    changeupdateunit() {
    	const _this=this;
    	this.goodsunitlists.forEach(function(e,index) {
    		if(_this.update.unitid==e.id) {
    			_this.update.sellprice=e.sell;
    			_this.update.marketprice=e.market;
    		}
    	});
    },
    
    changeaddunit() {
    	const _this=this;
    	this.goodsunitlists.forEach(function(e,index) {
    		if(_this.create.unitid==e.id) {
    			_this.create.sellprice=e.sell;
    			_this.create.marketprice=e.market;
    		}
    	});
    },
    

    updateSave() {
			this.updateLoading=true;
			var resource = this.$resource(this.url);
			this.update.act='checkgoodsprice';
	        resource.save(this.update).then((res) => {
	            if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	                this.updateLoading=false;
	            }else{
	                var result = JSON.parse(Base64.decode(res.data.Data));
                  if(result.length > 0) {
                    this.shownotice=[];
                    this.shownotice=result;
                    this.shownoticeDialog=true;
                    this.updateLoading=false;
                  }else {
                    this.updateLoading=false;
                    this.updategoodsSave();
                  }
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	            this.updateLoading=false;
	        });
		},

    //更新
    updategoodsSave(){
      // 主动校验
      this.shownoticeDialog=false;
      this.$refs.update.validate((valid) => {
          if (valid) {
          	  this.update.photo=this.imgphotolists;
          	  this.update.phototype=this.imgtype;
              this.updateLoading=true;
              this.update.act='edit';
              var resource = this.$resource(this.url);
              resource.save(this.update).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.updateLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateDialog=false;
                    this.updateLoading=false;
                    this.getList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.updateDialog=false;
                  this.updateLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },

    //删除
    delCurrent(item){
      this.$confirm('此操作将永久删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' })
              .then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')})
                  .then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.name + '!');
                    this.getList();
                  }
              }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
               });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    },
    
	/** 上传详情图片信息start **/
    addhandleSuccess(file, fileList) { //图片上传成功                	
        var pic = JSON.parse(Base64.decode(fileList.response.Data));
        this.create.photo.push({name:fileList.name,url:this.GLOBAL.staticUrl+pic.imgsrc});       
    },
    
    
    /** 删除详情图片 **/
    addhandleRemove(file, fileList) {
    	var data=JSON.stringify(JSON.parse(Base64.decode(file.response.Data)));
    	var url=data.imgsrc;
    	var number='';
    	let _this=this;
    	
    	this.create.photo.forEach(function(item,i) {if(item.url==url) number=i});
    	this.create.photo.splice(number,1);
    	
    },
    
    handleUpdateSuccess(file, fileList) { //图片更新成功
      var pic = JSON.parse(Base64.decode(fileList.response.Data));
      this.update.photo.push({name:fileList.name,url:this.GLOBAL.staticUrl+pic.imgsrc});
    },
    handlePictureCardPreview(file) { //放大图片
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    /** 上传详情图片信息end **/
    
    /** 文本编辑器start **/
    createuploadSuccess(res,file) { //图片上传成功     
    	
    	//编辑商品信息时，商品详情调用该函数         
    	if(this.updateDialog==true) {this.edituploadSuccess(res,file);return false;}
    
    	// res为图片服务器返回的数据,获取富文本组件实例
        let quill = this.$refs.mycreateQuillEditor.quill;	
        let _this=this;
        var imgurl=JSON.parse(Base64.decode(res.Data));
        if(imgurl.Result > 0) {
        	this.$message.error(imgurl.msg);
        	this.uillUpdateImg=false;
        	return false;
        }
        
        imgurl=this.GLOBAL.staticUrl+imgurl.imgsrc;
        this.uploadimglists.push(imgurl);
        
        if(this.uploadimglists.length==this.uploadimgnumber) {
        	this.uploadimglists.sort();
        	this.uploadimglists.forEach(function(item,i) {
        		// 如果上传成功
			    if (res.Result === 0 && res.Data !== null) {
			    	// 获取光标所在位置
			        let length = quill.getSelection().index;
			        // 插入图片  res.info为服务器返回的图片地址
			        quill.insertEmbed(length, 'image', item)
			        // 调整光标到最后
			        quill.setSelection(length + 1);
			        _this.uillUpdateImg=false;
			    }else {
			        _this.$message.error('图片插入失败');
			        _this.uillUpdateImg=false;
			    }
        	});
        	
        	this.uploadimglists=[];
        	this.uploadimgnumber=0;
        }        
    },
    createuploadError() { //图片上传失败
    	this.$message.error('图片插入失败');
    },
    createbeforeUpload(file) { //图片上传之前
    	this.uploadimgnumber++;
    	this.uillUpdateImg=true;
    },
    
    edituploadSuccess(res,file) { //图片上传成功    
    	// res为图片服务器返回的数据,获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill;	
        let _this=this;	
        var imgurl=JSON.parse(Base64.decode(res.Data));
        if(imgurl.Result > 0) {
        	this.$message.error(imgurl.msg);
        	this.uillUpdateImg=false;
        	return false;
        }
        
        imgurl=this.GLOBAL.staticUrl+imgurl.imgsrc;
        this.uploadimglists.push(imgurl);
        
        if(this.uploadimglists.length==this.uploadimgnumber) {
        	this.uploadimglists.sort();
        	this.uploadimglists.forEach(function(item,i) {
        		// 如果上传成功
			    if (res.Result === 0 && res.Data !== null) {
			    	// 获取光标所在位置
			        let length = quill.getSelection().index;
			        // 插入图片  res.info为服务器返回的图片地址
			        quill.insertEmbed(length, 'image', item)
			        // 调整光标到最后
			        quill.setSelection(length + 1);
			        _this.uillUpdateImg=false;
			    }else {
			        _this.$message.error('图片插入失败');
			        _this.uillUpdateImg=false;
			    }
        	});
        	
        	this.uploadimglists=[];
        	this.uploadimgnumber=0;
        }  
    },
    
    edituploadError() { //图片上传失败
    	this.$message.error('图片插入失败');
    },
    editbeforeUpload() { //图片上传之前
    	this.uploadimgnumber++;
    	this.uillUpdateImg=true;
    },
    /** 文本编辑器end **/
    
    //修改推荐排序
    changerec(obj) {
    	// 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({act:'changerecsort',id:obj.id,sort:obj.rec_sort,token:this.$cookies.get('token')})
        	.then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                //this.$message.success('修改'+obj.name+'推荐排序成功!');
            }
        }).catch((res) => {
        	this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    //修改热卖排序
    changehot(obj) {
    	// 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({act:'changehotsort',id:obj.id,sort:obj.hot_sort,token:this.$cookies.get('token')})
        	.then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                //this.$message.success('修改'+obj.name+'推荐排序成功!');
            }
        }).catch((res) => {
        	this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    //获取功能权限
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
        console.log(this.actionauth, '66666666666666666666')

    },
    
    /** 生成分享二维码 **/
    sharecode() {
    	this.codeDialog=true;
    },
    
    /** 获取推广链接地址 **/
    getpushurl() {
    	// 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({act:'getshareurl',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
            	var data=JSON.parse(Base64.decode(res.data.Data));
                this.codeurl=data.url;
            }
        }).catch((res) => {
        	this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 修改 **/
    changebrand() {
    	this.isquerychange=true;
    },
    changesearch() {
    	this.isquerychange=true;
    },
    /** 切换供应商数据来源 **/
    changeagents() {
        this.isquerychange=true;
        this.query.isinventorywarn='';
        if(this.query.parentagentid!=100000) {
            this.query.percentlow='';
            this.query.percentheight='';
        }
        this.getList();
    },
    changesearchdatafrom() {
      this.isquerychange=true;
      this.query.percentlow='';
      this.query.percentheight='';
    },
    
    
    //详情图上传多图
    fileClick(){
    	document.getElementById('upload_file').click()
    },
    fileChange(el){    
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	for (let i = 0; i < el.target.files.length; i++) {
    		var formData = new FormData();
    		formData.append('file', el.target.files[i]);
            formData.append('sys_type', 'cz');
            formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    		resource.save(formData).then((res) => {
	            var data=JSON.parse(Base64.decode(res.body.Data));
	            if(data.Result > 0) {
	            	this.$message.error(data.msg);
	            }else {
	            	this.imgphotolists.push(data.imgsrc);
	            	this.imgtype.push(1);
		            if (!el.target.files[0].size) return;
			        this.fileList(el.target.files);
			        el.target.value = '';  
	            }
	        }).catch((res) => {
	        	//this.$message.error(this.GLOBAL.errortext);
	        });

    	}
    },
    fileList(files){
        for (let i = 0; i < files.length; i++) this.fileAdd(files[i]);
    },
    fileAdd(file){   
        this.size = this.size + file.size;//总大小
        let reader = new FileReader();
        reader.vue = this;
        reader.readAsDataURL(file);
        reader.onload = function () {
          file.src = this.result;
          this.vue.imgList.push({file});
        }
    },
    fileDel(index){
        this.size = this.size - this.imgList[index].file.size;//总大小
        this.imgList.splice(index, 1);
        this.imgphotolists.splice(index,1);
        this.imgtype.splice(index,1);
    },
    bytesToSize(bytes){
        if (bytes === 0) return '0 B';
        let k = 1000, // or 1024
        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
        return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
    },
    dragenter(el){
        el.stopPropagation();
        el.preventDefault();
    },
    drop(el){
        el.stopPropagation();
        el.preventDefault();
        this.fileList(el.dataTransfer.files);
    },
    
    //选择分类图片
    filecateimgChange(obj,index) {
    	var file=obj.target.files[0]; //获取文件信息
    	
    	this.createpropertyloading=true;
    	var formData = new FormData();
    	formData.append('file', file);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		    	this.$message.error(data.msg);
		    	this.createpropertyloading=false;
		    }else {
	        	this.create.property_img[index]=data.imgsrc;
	        	this.create.cateimglists[index]=this.GLOBAL.staticUrl+data.imgsrc;
	        	//使数组变更，防止不冒泡新添加的图片不显示
	        	this.create.cateimglists.push('');
	        	this.create.cateimglists.splice(this.create.cateimglists.length-1,1);
	        	this.createpropertyloading=false;	        	
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	        this.createpropertyloading=false;
	    });
    },
    
    fileeditcateimgChange(obj,index) {
    	var file=obj.target.files[0]; //获取文件信息
    	
    	this.createpropertyloading=true;
    	var formData = new FormData();
    	formData.append('file', file);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		    	this.$message.error(data.msg);
		    	this.createpropertyloading=false;
		    }else {
	        	this.update.property_img[index]=data.imgsrc;
	        	this.update.cateimglists[index]=this.GLOBAL.staticUrl+data.imgsrc;
	        	//使数组变更，防止不冒泡新添加的图片不显示
	        	this.update.cateimglists.push('');
	        	this.update.cateimglists.splice(this.update.cateimglists.length-1,1);
	        	this.createpropertyloading=false;	        	
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	        this.createpropertyloading=false;
	    });
    },
    
    
    //获取推荐位信息
    getspecial() {
    	this.$emit('listenchild',{name:'商品专区管理',url:'Goodsspecial'});
    },
 	   
    //获取推荐位信息列表
    getspeciallists() {
    	if(this.specialchange==true) {
    		this.specialquery.p=1;
    		this.specialquery.rollpage=10;
    	}
    
    	this.specialLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.specialquery).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.specialLoading=false;
            }else{
            	this.specialists=JSON.parse(Base64.decode(res.data.Data));
            	this.specialcount=parseInt(res.data.count);
                this.specialLoading=false;
                if(this.specialchange==true) this.specialchange=false;
            }
        }).catch((res) => {
        	//this.$message.error(this.GLOBAL.errortext);
        	this.specialLoading=false;
        });
    },
    specialpageSizeChange(val) {
        this.specialquery.rollpage = val;
        this.getspeciallists();
    },
    specialpageCurrentChange(val) {
        this.specialquery.p = val;
        this.getspeciallists();
    },
    //修改专区品牌
    specialbrandchange() {
    	this.specialchange=true;
    	this.getspeciallists();
    },
    //修改专区位
    specialpchange() {
    	this.specialchange=true;
    	this.getspeciallists();
    },
    //修改专区关键字
 	specialkeychange() {
 		this.specialchange=true;
    	this.getspeciallists();
 	},
 	
    
    //修改专区商品排序
    changesort(id,i,specialid) {
    	var sort='';
    	this.specialists.forEach(function(e,index) {
    		specialid==1 && i==index ? sort=e.newsort : '';
    		specialid==2 && i==index ? sort=e.specialsort : '';
    		specialid==3 && i==index ? sort=e.bannersort : '';
    	});
    	
    	var resource = this.$resource(this.url);
        resource.save({act:'changespecialsort',id:id,sort:sort,specialid:specialid,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
            	this.getspeciallists();
            }
        }).catch((res) => {
        	//this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    //将商品从推荐位上撤下
    delspecial(item,specialid) {
    	this.$confirm('您是否要将该商品从该推荐位上撤下来, 是否继续?', '提示', { type: 'warning' }).then(() => {
        	// 向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save({act:'delspecial',id:item.id,specialid:specialid,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.$message.success('推荐位上撤销商品成功!');
                    this.getspeciallists();
                    this.getList();
                }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
            //this.$message.info('已取消操作!');
        });
    },
    
    //新增商品专区
    addspecial() {
    	if(this.specialquery.specialid==1) this.addspecialname="新增（新品专区）商品信息";
    	if(this.specialquery.specialid==2) this.addspecialname="新增（特价专区）商品信息";
    	if(this.specialquery.specialid==3) this.addspecialname="新增（品牌专区）商品信息";
    	this.addspecialgoodsDialog=true;
    	
    	this.addspecialquery.brandid='';
        this.addspecialquery.specialid=this.specialquery.specialid;
        this.addspecialquery.key='';
        this.addspecialquery.rollpage=10;
        this.addspecialquery.p=1;      
    	this.getaddspecial();
    },
    
    //获取商品专区商品
    getaddspecial() {
    	if(this.specialgoodsselect==true) {
    		this.addspecialquery.p=1;
    		this.addspecialquery.rollpage=10;
    	}
    
    	this.specialgoodsLoading=true;
    	var resource = this.$resource(this.url);
        resource.query(this.addspecialquery).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.specialgoodsLoading=false;
            }else{
            	this.specialgoodslists=JSON.parse(Base64.decode(res.data.Data));
            	this.specialgoodscount=parseInt(res.data.count);
            	
            	//填充商品信息状态
            	var _this=this;
            	this.multipleSelection=[];
            	this.specialgoodslists.forEach(function(e,index) {
            		_this.specialgoodsstatus[index]=0;
            	});
                this.specialgoodsLoading=false;
                if(this.specialgoodsselect==true) this.specialgoodsselect=false;
            }
        }).catch((res) => {
        	//this.$message.error(this.GLOBAL.errortext);
        	this.specialgoodsLoading=false;
        });
    },
    specialgoodspageSizeChange(val) {
        this.addspecialquery.rollpage = val;
        this.getaddspecial();
    },
    specialgoodspageCurrentChange(val) {
        this.addspecialquery.p = val;
        this.getaddspecial();
    },
    
    
    /** 点击单行触发事件 **/
    selectrow(row,event,column) {
    	var id=row.id;
    	var number=0;
    	var isselect=0;
    	var mnumber=0;
    	var _this=this;
    	
    	//获取当前商品在商品列表里的位置
    	this.specialgoodslists.forEach(function(e,index) {if(id==e.id) number=index});
    	//给该位置进行勾选或取消勾选
    	this.specialgoodsstatus[number]==0 ? this.specialgoodsstatus[number]=1 : this.specialgoodsstatus[number]=0;
		//判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品
		this.$refs.multipleTable.toggleRowSelection(this.specialgoodslists[number]);
		this.multipleSelection.forEach(function(e,index) {
			if(id==e.id) {
				isselect=1;
				mnumber=index;
			}
		});
		
		if(isselect==1) {
			this.multipleSelection.splice(mnumber,1);
		}else {
			this.multipleSelection.push(this.specialgoodslists[number]);
		}
    },
    
    /** 点击每行前面的选择框勾选/取消勾选商品 **/
    handleSelectsingle(val,row) {    	
    	var id=row.id;
    	var number=0;
    	var isselect=0;
    	var pnumber=0;
    	var _this=this;
    	
    	//获取当前商品在商品列表里的位置
    	this.specialgoodslists.forEach(function(e,index) {if(id==e.id) number=index});   	
    	//给该位置进行勾选或取消勾选
    	this.specialgoodsstatus[number]==0 ? this.specialgoodsstatus[number]=1 : this.specialgoodsstatus[number]=0;
		
		//判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品
		this.multipleSelection.forEach(function(e,index) {
			if(id==e.id) {
				isselect=1;
				pnumber=index;
			}
		});
		
    	if(isselect==1) {
			this.multipleSelection.splice(pnumber,1);
		}else {	
			this.multipleSelection.push(this.specialgoodslists[number]);
		}
    },
    
    /** 点击选全部可见商品 **/
    handleSelectall(val) {     	    	
    	var _this=this;  	
    	this.multipleSelection=[];
    	
    	val.forEach(function(e,index) {_this.multipleSelection.push(e)});
    	this.specialgoodsstatus.forEach(function(e,index) {
    		val=='' ? _this.specialgoodsstatus[index]=0 : _this.specialgoodsstatus[index]=1;
    	});
    },
    
    /** 设置商品信息的排序后自动更新到已选中的商品里 **/
    setSelectionsorts(id,sort) {
    	var _this=this;
    	this.addspecialquery.specialid;
    	this.multipleSelection.forEach(function(e,index) {
    		//新品专区
    		if(id==e.id && _this.addspecialquery.specialid==1) _this.multipleSelection[index].newsort=sort;
    		//特价专区
    		if(id==e.id && _this.addspecialquery.specialid==2) _this.multipleSelection[index].specialsort=sort;
    		//品牌专区
    		if(id==e.id && _this.addspecialquery.specialid==3) _this.multipleSelection[index].bannersort=sort;
    	});
    },
    
    /** 保存新增的商品信息 **/
    addspecialgoodsSave() {
    	if(this.multipleSelection.length==0) {this.$message.error("请选择要新增到专区的商品");return false;}
    	
    	this.addspecialgoodsLoading=true;
    	var resource = this.$resource(this.url);
        resource.save({act:'addspecialgoods',specialid:this.addspecialquery.specialid,token:this.$cookies.get('token'),goods:this.multipleSelection}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.$message.success('添加商品到专区成功!');
                this.addspecialgoodsLoading=false;
                this.addspecialgoodsDialog=false;
                this.getspeciallists();
                this.getList();
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.addspecialgoodsLoading=false;
        });  	
    },
    
    //获取新国货活动的信息（新国货活动结束后删除，2019年1月2日删除该方法）
    agentinternals() {
    	var resource = this.$resource(this.url);
        resource.save({act:'getinternals',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                var infos=JSON.parse(Base64.decode(res.data.Data));
                if(infos.result==1) this.internals.push({value:'3',name:'新国货'});
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });  	
    },
    
    closetag() {
    	this.tagshow='false';
    },
    
    
    //获取商品标签列表
	getlabellists() {
	    var _this=this;
		var updatelabelids=[];
		if(this.update.labelids.length > 0) {
			this.update.labelids.forEach(function(item,index) {
				updatelabelids.push(item.id);
			});
		}
			
		this.labellists.forEach(function(item,index) {
			_this.labellists[index].type='info';
			_this.labellists[index].isselect=false;
			if(updatelabelids.indexOf(item.id)!=-1) {
				_this.labellists[index].type='success';
				_this.labellists[index].isselect=true;
			}
				
			if(item.child.length > 0) {
				item.child.forEach(function(t,i) {
					_this.labellists[index].child[i].type='info';
					_this.labellists[index].child[i].isselect=false;
					if(updatelabelids.indexOf(t.id)!=-1) {
						_this.labellists[index].child[i].type='success';
						_this.labellists[index].child[i].isselect=true;
					}
				});
			}
				
		});
	    
	    this.labelDialog=true;
	},
	
	//选择父类商品标签
	selectparentlabel(index) {	  	    	  
	    this.labellists[index].type=='info' ? this.labellists[index].type='success' : this.labellists[index].type='info';	
	    this.labellists[index].isselect==false ? this.labellists[index].isselect=true : this.labellists[index].isselect=false;	    
	},
	    
	//选择子类商品标签
	selectchildlabel(index,i) {
	    this.labellists[index].child[i].type=='info' ? this.labellists[index].child[i].type='success' : this.labellists[index].child[i].type='info';	
	    this.labellists[index].child[i].isselect==false ? this.labellists[index].child[i].isselect=true : this.labellists[index].child[i].isselect=false;	    	    	
	},
	
	//保存已选中的标签
	savelabels() {
	    var lblists=[];	    	
	    this.labellists.forEach(function(item,i) {
	    	item.isselect==true ? lblists.push({id:item.id,name:item.name}) : '';
	    	if(item.child.length>0) {
	    		item.child.forEach(function(t,i) {
	    			t.isselect==true ? lblists.push({id:t.id,name:t.name}) : '';
	    		});
	    	}
	    });
	    	
	    if(lblists.length==0) {this.$message.error("请选择要添加的标签");return false;}
	    this.update.labelids=lblists;
	    this.labelDialog=false;
	},
	    
	//删除已选中的标签信息
	delselectlabel(index) {
	    this.update.labelids.splice(index,1);
	},
	
	
	//修改商品分类
	changecatid() {
	    var isnotice=false;
	    if(this.update.labelids.length > 0) isnotice=true;
	    if(isnotice) { //提示		
	    	this.$confirm('修改商品分类信息会清空商品标签，是否继续?', '提示', { type: 'warning' }).then(() => {  
	    		this.update.labelids=[];  
	    		this.oldcatid=this.update.catid;	    	
		 		this.getcatlabel();	        	
	        }).catch(() => {
	            //this.$message.info('已取消操作!');
	            this.update.catid=this.oldcatid;
	        });	    		
	    }else { //不用提示
	    	this.getcatlabel();
	    	this.oldcatid=this.update.catid;
	    }	    
	},
	    
	//获取分类绑定标签信息
	getcatlabel() {
		var resource = this.$resource(this.url);
		resource.save({act:'getcatidlabels',token:this.$cookies.get('token'),catid:this.update.catid}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
			}else{
				this.labellists=JSON.parse(Base64.decode(res.data.Data));
			}
		}).catch((res) => {
		
		});
	},

  /** 获取京东进货预存金额 **/
	getjdlastmoney() {
		  var resource = this.$resource(this.GLOBAL.domain+"Product/index");		    
	    resource.query({act:'getjdlastmoney',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    this.jdmoneys = JSON.parse(Base64.decode(res.data.Data));
			}
	    }).catch((res) => {
	        
	    });
	},

  /** 导出线上商城在线商品 **/    
  exportgoods() {
      this.exportDialog=true;
      this.exportloading=true;
      var resource = this.$resource(this.GLOBAL.exportUrl+'Goods/index');		    
	    resource.query({
            act:'exportgoods',
            token:this.$cookies.get('token'),
            brandid:this.query.brandid,
            key:this.query.key,
            datafrom:this.query.datafrom,
            has_thumb: this.query.has_thumb
        }).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.exportloading=false;
          }else{
              this.exportdata = JSON.parse(Base64.decode(res.data.Data));
              console.log('this.exportdata =====>', this.exportdata);
              this.exportloading=false;
          }
	    }).catch((res) => {
	        this.exportloading=false;
	    });
  }, 

  /** 导出商品信息 **/
  sureoutput() {
      var result={tHeader:'',filterVal:'',name:'',data:''};
      this.query.datafrom ? '' : this.query.datafrom=1; //没设置到处数据时默认到处宠赞数据

       result.tHeader=['id','商品名称','条形码','规格','上下架','零售价','批发价','活动到手价', '有效期至'];
       result.filterVal=['id','name','barcode','spec','isgrounding','market','price', 'especially_price', 'expire_at'];
       result.name="商城商品信息表";
       result.data=this.exportdata;
      /**
      if(this.query.datafrom==1) { //宠赞商品
          result.tHeader=['sku','品牌名称','商品名称','规格','上/下架','价格'];
          result.filterVal=['sku','brandname','name','spec','isgrounding','price'];
          result.name="宠赞商品信息表";
          result.data=this.exportdata;
      }else if(this.query.datafrom==2) { //京东商品
          result.tHeader=['品牌名称','sku','商品名称','规格','上/下架','京东商品上/下架','价格','商品销售价','京东商品协议销售价'];
          result.filterVal=['brandname','sku','name','spec','isgrounding','jdstate','price','jdsellprice','jdprice'];
          result.name="京东商品信息表";
          result.data=this.exportdata;
      }
      */
      this.setsureoutput(result);
  },

  /** 确认导出订单信息 **/
  setsureoutput(item) {
		  require.ensure([], () => {
			  var { export_json_to_excel } = require('../../vendor/Export2Excel');
			  var tHeader = item.tHeader;
			  var filterVal = item.filterVal;
				
			  var list = item.data;
			  var data = this.formatJson(filterVal, list);

			  export_json_to_excel(tHeader, data, item.name);
			  this.exportDialog=false;
		  })
  },
    
  //导出表格数据
  formatJson(filterVal, jsonData) {
　　  return jsonData.map(v => filterVal.map(j => v[j]));
　},

  //导出同步的线上商城京东来源的商品信息
  exportmoresyndata() {
      this.$emit('listenchild',{name:'导出同步数据',url:'exportsyndata'});
  },

  /** 编辑其它代理商品牌信息 **/
  editbrands(item) {
      this.editbrandquery.id=item.id;
      this.editbrandquery.brandid='';
      this.editbrandDialog=true;
  },

  /** 保存编辑的代理商商品品牌信息 **/
  savegoodsbrand() {
      this.editbrandloading=true;
      var resource = this.$resource(this.url);		    
	    resource.query(this.editbrandquery).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.editbrandloading=false;
          }else{
              this.editbrandloading=false;
              this.editbrandDialog=false;
              this.getList();
          }
	    }).catch((res) => {
	        this.editbrandloading=false;
	    });
  },

  
  /** 修改商品单位信息 **/
  changeunits(item,index) {
      this.$confirm('修改该商品规格的销售单位信息后请注意调整商品价格、重量以及商品所参加的活动的优惠信息，是否确定要修改该销售单位 ？', { type: 'warning' }).then(() => {
		  this.update.oldunitids[index]=this.update.unitids[index];
	  }).catch(() => {
		  this.update.unitids[index]=this.update.oldunitids[index];
          this.update.unitids=JSON.parse(JSON.stringify(this.update.unitids));
	  });
  },


  } 
}
</script>

<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.upload_warp_img_div_del {position: absolute;top: 6px;width: 16px;right: 4px;}
.upload_warp_img_div_top {position: absolute;top: 0;width: 100%;height: 30px;background-color: rgba(0, 0, 0, 0.2);line-height: 30px;text-align: left;color: #fff;font-size: 12px;text-indent: 4px;}
.upload_warp_img_div_text {white-space: nowrap;width: 100%;overflow: hidden;text-overflow: ellipsis;}
.upload_warp_img_div img {max-width: 80%;max-height: 80%;vertical-align: middle;}
.upload_warp_img_div {position: relative;height: 100px;width: 120px;border: 1px solid #ccc;margin: 0px 30px 10px 0px;float: left;line-height: 100px;display: table-cell;text-align: center;background-color: #fbfdff;cursor: pointer;}
.upload_warp_img {border-top: 1px solid #D2D2D2;padding: 14px 0 0 14px;overflow: hidden;border-top:none}
.upload_warp_text {text-align: left;margin-bottom: 10px;padding-top: 10px;text-indent: 14px;font-size: 14px;}
.upload_warp_right {float: left;width: 57%;margin-left: 2%;height: 100%;border: 1px dashed #999;border-radius: 4px;line-height: 130px;color: #999;}
.upload_warp_left {float: left;width: 120px;height: 100px;border-radius: 4px;cursor: pointer;}
.upload_warp {margin: 14px;height: 130px;}
.upload {border: 1px solid #ccc;background-color: #fff;width: 100%;border-radius: 4px;}
.hello {width: 100%;text-align: center;}
.cateimg {margin-top:5px}
.cateimg input[type=file] {position:absolute;margin-left:-5px;height:50px;opacity:0;filter:alpha(opacity=0);cursor:pointer}
.cateimg img {width:100%;border:1px solid #D2D2D2;border-radius:6px}
.goods-infos-main {position:relative;display:flex;align-items: center;justify-content: center;float:left;width:60px;height:60px;border-radius:6px}
.goods-infos-main img {width:100%;}
.goods-infos-type-jd {position:absolute;margin:-60px 0 0 -45px;width:18px;height:18px;}
.goods-infos-type-cz {padding:.1rem .4rem;background:#67C23A;border-color:#67C23A;color:#fff;border-radius:50%;position:absolute;font-size:.1rem;font-style:normal;margin:-.6rem}
.goods-infos-name-main {float:left;width:70%}
.goods-infos-name-name {float:left;width:84%;margin-left:5%;font-size:13px;line-height:21px;}
.goods-infos-name-split {font-style:normal;margin-left:2px;background:#f9d040;color:#303133;padding:.1rem .5rem;border-radius:15px;font-size:.3rem;line-height:.8rem;}
.goods-infos-name-spec {float:left;width:95%;margin-left:5%;color:#909399;font-size:12px;}
.goods-infos-name-sku {float:left;width:100%;margin-left:2%;color:#909399;font-size:12px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.goods-infos-name-agent {float:left;width:100%;margin-left:2%;margin-top:5px;width:98%;font-size:.3rem;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.goods-infos-name-agent i  {float:left;font-style:normal;padding:0 10px;line-height:18px;border-radius:15px;color:#fff;background:#F56C6C;font-size:12px}

.cz-goods-brand-grant-out {display:flex;align-items:center;justify-content:left;}
.cz-goods-brand-grant-icon {width:15px;height:15px;display:inline-block;}
.cz-goods-brand-grant-name {font-size:12px;display:inline-block;margin-left:4px;}
.cz-goods-brand-grant-btn {display:none;margin-left:5px;font-size:13px;color:#909399;text-decoration:none}
.cz-goods-brand-grant-out:hover .cz-goods-brand-grant-btn {display:inline-block;}
.cz-goods-brand-grant-btn img {width:15px;height:15px;margin-top:5px;}

.sasinside {float:left;width:100%;padding:1% 0 1% 0;overflow:auto}
.sastable {border-collapse:collapse;}
.sastable table {float:left;width:100%}
.sastable th {font-size:14px;line-height:23px;padding:10px;color:#909399;border:1px solid #ebeef5;vertical-align:middle;width:auto;white-space:nowrap;}
.sastable td {font-size:14px;line-height:23px;padding:10px;color:#606266;border:1px solid #ebeef5;vertical-align:middle;width:auto;white-space:nowrap;}

.warningnotice {margin-top:10px;border-radius:5px;padding:.2rem 1% .2rem 1%;background:rgb(211,211,211,.6);overflow:hidden;transition:all .5s}
.goods-edit-infos th>.cell {font-weight:500;font-size:13px;color:#333336}
.goods-edit-infos .el-input {font-size:13px}
.goods-edit-infos .el-input__inner {height:28px;line-height:28px}
.mall-goods-base .el-form-item__label {font-size:13px}
.cz-mall-goods {float:left;border-radius:5px}

.sys-offers-details-brand-grant-no {font-size:12px;color:#fff;background:#909399;line-height:12px;padding:3px 0;border-radius:15px;font-style:normal;text-align:center;margin-top:5px;padding:3px 10px}
.sys-offers-details-brand-grant-yes {font-size:12px;color:#fff;background:#67C23A;line-height:12px;padding:3px 0;border-radius:15px;font-style:normal;text-align:center;margin-top:5px;padding:3px 10px}
.mall-goods-show-spu {display:inline-block;transition:all .5s; color:#999999;background-color:#cccccc;padding:5px 20px;margin-left:10px;font-size:13px;border-radius:15px 15px 0 0;cursor:pointer}
.mall-goods-show-spu-on,.mall-goods-show-spu:hover  {background-color:#fff;color:#333336}
</style>



// WEBPACK FOOTER //
// src/components/mall/Goods.vue